Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const slideAnimation = (() => {
  const animatingElements = {};

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animationType: "slideToggle",
      duration: 250,
      easing: "ease",
      isDisplayStyle: "block",
      parent: false,
    };

    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const parent = options.parent;

    if (!target) {
      return;
    }

    const uniqueKey = `node-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const targetKey = target.dataset.uniqueKey || uniqueKey;

    if (!target.dataset.uniqueKey) {
      target.dataset.uniqueKey = uniqueKey;
    }

    if (options.forceAnimating) {
      animatingElements[targetKey] = false;
    }

    if (animatingElements[targetKey]) {
      return;
    }

    animatingElements[targetKey] = true;

    let animationType = options.animationType;
    const styles = getComputedStyle(target);

    if (animationType === "slideToggle") {
      animationType = (styles.display === "none") ? "slideDown" : "slideUp";
    }

    if ((animationType === "slideUp" && styles.display === "none") ||
      (animationType === "slideDown" && styles.display !== "none") ||
      (animationType !== "slideUp" && animationType !== "slideDown")) {

      animatingElements[targetKey] = false;

      return false;
    }

    target.style.overflow = "hidden";

    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animationType === "slideDown") {
      target.style.display = isDisplayStyle;
    }

    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });

    if (Object.keys(heightVal).length === 0) {
      animatingElements[targetKey] = false;

      return false;
    }

    let slideAnimation;

    if (animationType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });

      slideAnimation = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animationType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });

      slideAnimation = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }

    slideAnimation.finished.then(() => {
      target.style.overflow = "";

      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });

      if (animationType === "slideUp") {
        target.style.display = "none";

        if (parent.tagName === "DETAILS") {
          parent.removeAttribute("open");
          parent.setAttribute("aria-expanded", "false");
        }
      }

      animatingElements[targetKey] = false;
    });

    parent.classList?.toggle("active");
  };
})();


class MenuDrawer extends Drawer {
  constructor() {
    super();

    this.collapsibleBlocks = this.querySelectorAll(".collapsible-block");
    this.footer = this.querySelector(".drawer__footer");

    this.allowOneOpenedTab();
    this.setFooterHeight();
  }

  close() {
    super.close();

    this.closeAllCollapsibleBlocks();
  }

  allowOneOpenedTab() {
    this.collapsibleBlocks.forEach((block) => {
      const summary = block.querySelector("summary");

      summary.addEventListener("focus", (evt) => {
        const isSecondLevel = block.closest(".level-1");

        if (isSecondLevel) {
          const parentFirstLevel = block.closest(".level-0");
          const secondLevelTabs = parentFirstLevel.querySelectorAll(".level-1 .collapsible-block");

          secondLevelTabs.forEach((innerBlock) => {
            if (block === innerBlock || !innerBlock.classList.contains("active")) {
              return;
            }

            slideAnimation({
              target: innerBlock.querySelector(".collapsible-content"),
              parent: innerBlock,
              animationType: "slideUp",
              forceAnimating: true
            });
          });
        } else {
          this.collapsibleBlocks.forEach((innerBlock) => {
            if (block === innerBlock || !innerBlock.classList.contains("active")) {
              return;
            }

            slideAnimation({
              target: innerBlock.querySelector(".collapsible-content"),
              parent: innerBlock,
              animationType: "slideUp",
              forceAnimating: true
            });
          });
        }
      });
    });
  }

  closeAllCollapsibleBlocks() {
    this.collapsibleBlocks.forEach((block) => {
      const content = block.querySelector(".collapsible-content");

      if (block.classList.contains("active")) {
        slideAnimation({
          target: content,
          parent: block,
          animationType: "slideToggle",
          forceAnimating: true
        });
      }
    });
  }

  setFooterHeight() {
    if (!this.footer) return;

    this.style.setProperty("--footer-height", `${this.footer.getBoundingClientRect().height}px`);

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === this.footer) {
          this.style.setProperty("--footer-height", `${this.footer.getBoundingClientRect().height}px`);
        }
      }
    });

    resizeObserver.observe(this.footer);
  }
}

if (!window.customElements.get("menu-drawer")) {
  customElements.define("menu-drawer", MenuDrawer);
}


class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super();

    this.link = this.querySelector("a");

    this.link.addEventListener("click", (evt) => {
      evt.preventDefault();
    }, false);

    this.addEventListener("click", this.onToggle.bind(this), false);
  }

  onToggle() {
    this.classList.toggle("is-open");
  }
}

if (!window.customElements.get("open-children-toggle")) {
  customElements.define("open-children-toggle", OpenChildrenToggle);
}


class SearchDrawer extends Drawer {
  constructor() {
    super();

    this.footer = this.querySelector(".drawer__footer");
    this.predictiveSearch = this.querySelector("predictive-search");
    this.input = this.querySelector("input[type='search']")
    this.submit = this.querySelector("button[type='submit']");

    this.predictiveSearch?.addEventListener("theme:predictive-search:has-results", () => {
      this.footer.classList.remove("drawer__footer--hidden");
      this.submit.removeAttribute("disabled");

      document.dispatchEvent(new CustomEvent("hover-button:apply"));
    });

    this.predictiveSearch?.addEventListener("theme:predictive-search:no-results", () => {
      this.footer.classList.add("drawer__footer--hidden");
      this.submit.setAttribute("disabled", "disabled");

      document.dispatchEvent(new CustomEvent("hover-button:apply"));
    });
  }

  get focusElement() {
    return this.querySelector("input[type='search']");
  }
}

if (!window.customElements.get("search-drawer")) {
  customElements.define("search-drawer", SearchDrawer);
}


class SearchTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".search-tabs__tab");
    this.searchBlocks = this.querySelectorAll(".search-tabs__blocks");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const blockId = tab.dataset.blockId;

        this.showContent(blockId);

        this.tabs.forEach((innerTab) => {
          innerTab.classList.remove("button-primary");
          innerTab.classList.add("button-outline");
          innerTab.removeAttribute("disabled");
        });

        tab.classList.add("button-primary");
        tab.classList.remove("button-outline");
        tab.setAttribute("disabled", "disabled");
      });
    });
  }

  showContent(blockId) {
    this.searchBlocks.forEach((productBlock) => {
      productBlock.classList.add("search-tabs__blocks--refreshing");

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("search-tabs__blocks--hidden");
        } else {
          productBlock.classList.add("search-tabs__blocks--hidden");
        }

        productBlock.classList.add("animated-blocks--hide-instantly");
        productBlock.classList.remove("visible");
        productBlock.classList.remove("search-tabs__blocks--refreshing");
      }, 300);

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("animated-blocks--hide-instantly");
          productBlock.classList.add("visible");
        }
      }, 500);
    });
  }
}

if (!window.customElements.get("search-tabs")) {
  customElements.define("search-tabs", SearchTabs);
}


class CartDrawer extends Drawer {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.actions = this.querySelectorAll(".cart-drawer__action");
    this.actionApplyButtons = this.querySelectorAll(".cart-drawer__action-apply-button");
    this.quantityInputs = this.querySelectorAll("[name='updates[]']");
    this.freeShippingBar = this.querySelector("free-shipping-bar");

    this.debouncedOnChange = theme.helpers.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initCartActions();

    this.addEventListener("drawer:open", () => {
      this.classList.remove("cart-drawer--opened");
    });
  }

  initCartActions() {
    this.actions = this.querySelectorAll(".cart-drawer__action");
    this.actionApplyButtons = this.querySelectorAll(".cart-drawer__action-apply-button");
    this.quantityInputs = this.querySelectorAll("[name='updates[]']");

    // Inputs
    this.quantityInputs.forEach((input) => {
      input.removeEventListener("change", this.debouncedOnChange.bind(this));
      input.addEventListener("change", this.debouncedOnChange.bind(this));
    });

    // Inner drawers
    this.actions.forEach((action) => {
      action.removeEventListener("click", this.initCartAction.bind(this), false);
      action.addEventListener("click", this.initCartAction.bind(this), false);
    });

    // Inner drawer save buttons
    this.actionApplyButtons.forEach((button) => {
      button.removeEventListener("click", this.initCartActionApply.bind(this), false);
      button.addEventListener("click", this.initCartActionApply.bind(this), false);
    });
  }

  initCartAction(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const action = target.dataset.action;

    if (action === "shipping") {
      const addressCountry = this.querySelector("#AddressCountry");
      const addressProvince = this.querySelector("#AddressProvince");

      if (!target.classList.contains("shipping-inited")) {
        if (addressCountry && addressProvince) {
          new Shopify.CountryProvinceSelector(
            "AddressCountry",
            "AddressProvince",
            { hideElement: "AddressProvinceContainer" }
          );
        }

        target.classList.add("shipping-inited");
      }
    }
  }

  initCartActionApply(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const action = target.dataset.action;
    const drawer = target.closest("drawer-inner");

    if (action === "note") {
      const body = JSON.stringify({
        note: this.querySelector(".cart-note").value,
      });

      target.classList.add("loading");

      fetch(`${window.routes.cartUpdateUrl}`, { ...theme.helpers.fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        }).catch((e) => {
        throw e;
      }).finally(() => {
        target.classList.remove("loading");
        drawer.close();
      });
    } else if (action === "gift") {
      const variantId = +target.dataset.variantId;

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: this.getSectionsToRender().map((section) => section.name),
        sections_url: window.location.pathname,
      });

      target.classList.add("loading");

      this.classList.add("start", "loading");

      setTimeout(() => {
        drawer.close();
      }, 200);

      fetch(`${window.routes.cartAddUrl}`, { ...theme.helpers.fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          this.updateCart(variantId, state, this);

          this.classList.remove("start", "loading");
        })
        .catch((e) => {
          throw e;
        }).finally(() => {
        target.classList.remove("loading");
      });
    } else if (action === "shipping") {
      target.classList.add("loading");

      const data = {
        zip: document.querySelector("#AddressZip").value || "",
        country: document.querySelector("#AddressCountry").value || "",
        province: document.querySelector("#AddressProvince").value || "",
      };

      this.getShippingRates(data, target);
    }
  }

  getShippingRates(data, button) {
    fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${data.zip}&shipping_address%5Bcountry%5D=${data.country}&shipping_address%5Bprovince%5D=${data.province}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const message = document.querySelector(".shipping-response");
        const successBanner = message.querySelector(".color-success");
        const errorBanner = message.querySelector(".color-error");

        message.classList.remove("!hidden");
        successBanner.classList.add("!hidden");
        errorBanner.classList.add("!hidden");

        const {
          showDeliveryDays,
          deliveryDayOne,
          deliveryDaysOther
        } = message.dataset;

        const parsedState = JSON.parse(state);

        if (parsedState && parsedState.shipping_rates) {
          if (parsedState.shipping_rates.length > 0) {
            successBanner.classList.remove("!hidden");

            const contentBlock = successBanner.querySelector("span");
            const addressInfo = window.cartStrings.shippingRate.replace("{{address}}", `${data.zip}, ${data.country} ${data.province}`);

            let content = `<p>${addressInfo}</p>`;

            parsedState.shipping_rates.map((rate) => {
              let daysShipping = "";

              if (rate.delivery_days.length > 0 && showDeliveryDays === "true") {
                let typeDay = deliveryDayOne;
                const day = rate.delivery_days[0];
                const dayAt = rate.delivery_days.at(-1);

                if (day > 1) {
                  typeDay = deliveryDaysOther;
                }

                if (day === dayAt) {
                  daysShipping = `(${day} ${typeDay})`;
                } else {
                  daysShipping = `(${day} - ${dayAt} ${typeDay})`;
                }
              }

              content += `<p>${rate.name}: ${Shopify.formatMoney(rate.price, window.settings.moneyFormat)} ${daysShipping}</p>`;
            });

            contentBlock.innerHTML = content;
          } else {
            errorBanner.classList.remove("!hidden");

            const contentBlock = errorBanner.querySelector("span");

            contentBlock.innerHTML = window.cartStrings.noShipping;
          }
        } else {
          errorBanner.classList.remove("!hidden");

          const contentBlock = errorBanner.querySelector("span");

          let content = "";

          Object.entries(parsedState).map((error) => {
            content += `${error[1][0]}<br>`;
          });

          contentBlock.innerHTML = content;
        }
      })
      .catch((error) => {
        throw error;
      }).finally(() => {
      button?.classList.remove("loading");
    });
  }

  onChange(evt) {
    const target = evt.target;

    this.updateQuantity(target.dataset.index, target.value, target.dataset.value, target);

    this.classList.add("cart-drawer--opened");
  }

  updateQuantity(id, quantity, currentQuantity, target) {
    quantity = quantity ? quantity : 0;

    const body = JSON.stringify({
      line: +id,
      quantity: +quantity,
      sections_url: window.location.pathname,
      sections: this.getSectionsToRender().map((section) => {
        return section.name;
      }),
    });

    this.classList.add("start", "loading");

    fetch(`${window.routes.cartChangeUrl}`, { ...theme.helpers.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.updateCart(id, state, target);
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.classList.remove("start", "loading");
      });
  }

  updateCart(id, state, target) {
    const parsedState = JSON.parse(state);

    if (parsedState.errors) {
      this.updateMessageErrors(id, parsedState.errors, target);

      target.value = target.dataset.value;

      return;
    }

    const itemCount = parsedState.item_count;

    if (itemCount > 0) {
      this.classList.remove("is-empty");
    } else {
      this.classList.add("is-empty");
    }

    document.dispatchEvent(new CustomEvent("theme:cart:count:update", {
      detail: {
        count: itemCount
      }
    }));

    this.getSectionsToRender().forEach((section) => {
      const html = new DOMParser().parseFromString(parsedState.sections[section.name], "text/html");
      const currentSection = document.getElementById(section.id).querySelector("#cart-drawer-form");

      const currentProducts = currentSection.querySelector(".cart-drawer__products");
      const currentFooter = currentSection.querySelector(".cart-drawer__footer");

      const parsedProducts = html.querySelector(".cart-drawer__products");
      const parsedFooter = html.querySelector(".cart-drawer__footer");

      if (currentFooter && parsedFooter) {
        let productsRange = document.createRange();
        let footerRange = document.createRange();

        productsRange = productsRange.createContextualFragment(parsedProducts.innerHTML);
        footerRange = footerRange.createContextualFragment(parsedFooter.innerHTML);

        currentProducts.replaceChildren(productsRange);
        currentFooter.replaceChildren(footerRange);
      } else {
        currentSection.innerHTML = html.querySelector("#cart-drawer-form").innerHTML;
      }

      const focusableElement = currentProducts?.querySelector("a");

      focusableElement?.focus();
    });

    this.freeShippingBar = this.querySelector("free-shipping-bar");

    if (this.freeShippingBar) {
      if (parsedState.items_subtotal_price) {
        this.freeShippingBar.init(parsedState.items_subtotal_price);
      } else {
        fetch(`${window.routes.cartUrl}.json`)
          .then((res) => res.json())
          .then((cart) => {
            this.freeShippingBar.init(cart.items_subtotal_price);
          })
          .catch((error) => {
            throw error;
          });
      }
    }

    this.initCartActions();

    document.dispatchEvent(new CustomEvent("hover-button:apply"));
  }

  updateMessageErrors(line, message, target) {
    target.setCustomValidity(message);
    target.reportValidity();
  }

  getSectionsToRender() {
    return [
      {
        name: this.sectionId,
        id: "CartDrawer",
      },
    ];
  }
}

if (!window.customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}


class CartCount extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("theme:cart:count:update", (event) => {
      const count = event.detail.count;

      const updateCount = (value) => {
        this.classList.toggle("!hidden", value === 0);

        if (this.classList.contains("cart-count--simplified")) {
          this.innerHTML = value > 99 ? "99+" : value;
        } else {
          this.innerHTML = value;
        }
      };

      if (Number.isInteger(count)) {
        updateCount(count);
      } else {
        fetch(`${window.routes.cartUrl}.json`)
          .then((res) => res.json())
          .then((cart) => {
            updateCount(cart.item_count);
          })
          .catch((error) => {
            throw error;
          });
      }
    });
  }
}

if (!window.customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const wrapper = this.closest("cart-drawer") || this.closest("cart-page");

      wrapper?.updateQuantity(this.dataset.index, 0);
    });
  }
}

if (!window.customElements.get("cart-remove-button")) {
  customElements.define("cart-remove-button", CartRemoveButton);
}


class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", theme.helpers.debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });

      fetch(`${window.routes.cartUpdateUrl}`, {
        ...theme.helpers.fetchConfig(),
        ...{ body },
      });
    }, 300));
  }
}

if (!window.customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}


class FreeShippingBar extends HTMLElement {
  constructor() {
    super();

    this.bar = this.querySelector(".progress");
    this.message = this.querySelector(".free-shipping-message");

    this.subtotalPrice = this.dataset.subtotalPrice;
    this.goal = this.dataset.goal;
    this.goalNotAchievedText = this.dataset.goalNotAchievedText;
    this.goalAchievedText = this.dataset.goalAchievedText;

    this.shopifyRate = +Shopify.currency.rate;

    if (this.subtotalPrice && this.goal && this.goalNotAchievedText && this.goalAchievedText && this.shopifyRate) {
      this.init();
    }
  }

  init(passedSubtotalPrice) {
    if (passedSubtotalPrice) {
      this.subtotalPrice = passedSubtotalPrice;
    }

    const subtotalPrice = +this.subtotalPrice / 100;
    const goalValue = this.goal * this.shopifyRate;

    this.setProgressBar((subtotalPrice / goalValue) * 100);
    this.setMessage(subtotalPrice, goalValue);
  }

  setMessage(subtotalPrice, goalValue) {
    if (!this.message) {
      return;
    }

    this.message.classList.remove("opacity-0");

    if (subtotalPrice >= goalValue) {
      this.message.innerHTML = this.goalAchievedText;
    } else {
      const leftAmount = (goalValue - subtotalPrice) * 100;
      const formattedLeftAmount = Shopify.formatMoney(leftAmount, window.settings.moneyFormat);

      this.message.innerHTML = this.goalNotAchievedText.replace("{{ amount }}", formattedLeftAmount);
    }
  }

  setProgressBar(percentage) {
    percentage = Math.min(percentage, 100);

    this.bar.style.setProperty("--progress", `${percentage}%`);
  }
}

if (!window.customElements.get("free-shipping-bar")) {
  customElements.define("free-shipping-bar", FreeShippingBar);
}


class ModalTrigger extends ModalBase {
  constructor() {
    super();

    this.modalCustomClass = this.dataset.modalCustomClass;
    this.modalHeaderTitle = this.dataset.modalHeaderTitle;

    this.addEventListener("click", this.openModal.bind(this));
    this.addEventListener("keydown", this.handleKeyPress.bind(this));
  }

  openModal(evt) {
    evt.preventDefault();

    const content = this.querySelector(".modal-content-markup");

    this.init({
      customClass: this.modalCustomClass,
      headerTitle: this.modalHeaderTitle,
      content: content,
    });

    this.open(this);
  }

  handleKeyPress(evt) {
    if (evt.key === "Enter" || evt.key === " ") {
      evt.preventDefault();

      this.openModal(evt);
    }
  }
}

if (!window.customElements.get("modal-trigger")) {
  customElements.define("modal-trigger", ModalTrigger);
}


class DrawerTrigger extends HTMLAnchorElement {
  constructor() {
    super();

    this.drawerId = this.getAttribute("drawer-id");

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const drawer = document.getElementById(this.drawerId);

      if (drawer) {
        drawer.open(this);
      }
    });
  }
}

if (!window.customElements.get("drawer-trigger")) {
  customElements.define("drawer-trigger", DrawerTrigger, { extends: "a" });
}


class HeaderSection extends HTMLElement {
  constructor() {
    super();

    this.settings = theme.helpers.safelyParseJson(this.getAttribute("data-settings")) || {};

    this.headerSection = document.querySelector(".header-section");
    this.header = this.headerSection.querySelector(".header");
    this.headerInner = this.headerSection.querySelector(".header__inner");
    this.headerMenuDrawerMarkup = this.headerSection.querySelector(".header-menu-drawer-markup");

    this.overlay = this.nextElementSibling;
    this.announcementBar = document.querySelector(".announcement-bar-section");
    this.disclosures = this.querySelectorAll(".disclosure");
    this.collapsibleBlocks = this.querySelectorAll(".collapsible-block");
    this.trigger = this.getAttribute("data-trigger");

    this.headerBounds = this.header.getBoundingClientRect();

    this.headerHeight = this.clientHeight;
    this.headerInnerHeight = this.headerInner.clientHeight;

    this.currentScrollTop = 0;

    this.showHeaderOverlay();
    this.moveDrawerOut();
    this.handleStickyHeader();
    this.setHeaderHeight();
    this.setStickyClass();
    this.closeOpenedCollapsibleBlocks();

    if (this.settings.layoutOnDesktop !== "logo-center-navigation-drawer") {
      this.hideMenuDrawerOnDesktop();
    }

    document.documentElement.style.setProperty("--header-height", `${Math.round(this.headerHeight)}px`);
    document.documentElement.style.setProperty("--header-inner-height", `${Math.round(this.headerInnerHeight)}px`);

    this.handleSectionLoadListener = this.handleSectionLoad.bind(this);
    this.handleBlockSelectListener = this.handleBlockSelect.bind(this);
    this.handleBlockDeselectListener = this.handleBlockDeselect.bind(this);
    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
    this.handleResizeListener = theme.helpers.throttle(this.handleResize.bind(this));
    this.handleTransitionEndListener = this.handleTransitionEnd.bind(this);
  }

  connectedCallback() {
    this.currentScrollTop = 0;

    window.addEventListener("scroll", this.handleScrollListener, { passive: true });
    window.addEventListener("resize", this.handleResizeListener, { passive: true });

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.handleSectionLoadListener);
      document.addEventListener("shopify:block:select", this.handleBlockSelectListener);
      document.addEventListener("shopify:block:deselect", this.handleBlockDeselectListener);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScrollListener);
    window.removeEventListener("resize", this.handleResizeListener);

    if (Shopify.designMode) {
      document.removeEventListener("shopify:section:load", this.handleSectionLoadListener);
      document.removeEventListener("shopify:block:select", this.handleBlockSelectListener);
      document.removeEventListener("shopify:block:deselect", this.handleBlockDeselectListener);
    }
  }

  handleSectionLoad() {
    this.headerBounds = this.header.getBoundingClientRect();

    this.handleStickyHeader();
    this.moveDrawerOut();
  }

  handleTransitionEnd() {
    if (!this.classList.contains("open")) {
      this.classList.remove("header--dropdown-was-opened");
    }

    this.overlay.removeEventListener("transitionend", this.handleTransitionEndListener, false);
  }

  closeOpenedCollapsibleBlocks() {
    this.collapsibleBlocks.forEach((block) => {
      const heading = block.querySelector(".collapsible-heading");
      const blockToListen = (this.trigger === "hover") ? block : heading;

      blockToListen.addEventListener("click", () => {
        const blocksToClose = Array.from(this.collapsibleBlocks).filter((innerBlock) => {
          return block !== innerBlock && innerBlock.classList.contains("active");
        });

        blocksToClose.forEach((blockToClose) => {
          const content = blockToClose.querySelector(".collapsible-content");

          slideAnimation({
            target: content,
            parent: blockToClose,
            animationType: "slideToggle",
            forceAnimating: true
          });
        });
      });
    });
  }

  setStickyClass() {
    if (!this.settings.enableStickyHeader) {
      return;
    }

    this.headerSection.classList.add(`header-section--sticky-${this.settings.stickyHeaderVisibility}`);
  }

  handleScroll() {
    this.setHeaderHeight();
    this.handleStickyHeader();
    this.closeOpenedMenus();
  }

  handleResize() {
    this.setHeaderHeight();
  }

  closeOpenedMenus() {
    this.disclosures.forEach((disclosure) => {
      const button = disclosure.querySelector(".disclosure__button");

      if (button.classList.contains("open")) {
        disclosure.hidePanel();
      }
    });
  }

  setHeaderHeight() {
    if (this.clientHeight !== this.headerHeight) {
      document.documentElement.style.setProperty("--header-height", `${Math.round(this.clientHeight)}px`);

      this.headerHeight = this.clientHeight;
    }

    if (this.headerInner.clientHeight !== this.headerInnerHeight) {
      document.documentElement.style.setProperty("--header-inner-height", `${Math.round(this.headerInner.clientHeight)}px`);

      this.headerInnerHeight = this.headerInner.clientHeight;
    }
  }

  handleBlockSelect(evt) {
    if (evt.target && evt.target.openSelector) {
      const isInsideHeader = evt.target.closest("[is='header-section']");

      if (isInsideHeader) {
        evt.target.openSelector(evt);
        evt.target.classList.add("disclosure--not-close");
      }
    }
  }

  handleBlockDeselect(evt) {
    this.disclosures.forEach((item) => {
      item.classList.remove("disclosure--not-close");
      item.hidePanel();
    });
  }

  showHeaderOverlay() {
    this.disclosures.forEach((item) => {
      const button = item.querySelector(".disclosure__button");

      if (!button) {
        return;
      }

      const observer = new MutationObserver(() => {
        this.overlay.removeEventListener("transitionend", this.handleTransitionEndListener, false);

        const hasOpenedDisclosure = Array.from(this.disclosures).some((disclosure) => {
          const button = disclosure.querySelector(".disclosure__button");

          if (!button) {
            return;
          }

          const isMegaMenu = !!button.closest(".header__mega-menu");

          if (isMegaMenu && button.classList.contains("open")) {
            this.classList.add("header--mega-menu-opened");
          } else {
            this.classList.remove("header--mega-menu-opened");
          }

          this.classList.add("header--dropdown-was-opened");

          return button.classList.contains("open");
        });

        this.classList.toggle("open", hasOpenedDisclosure);
        this.announcementBar?.classList.toggle("announcement-bar-section--header-opened-menu", hasOpenedDisclosure);

        this.overlay.addEventListener("transitionend", this.handleTransitionEndListener, false);
      });

      observer.observe(button, {
        attributes: true,
        childList: false,
        subtree: false
      });
    });
  }

  moveDrawerOut() {
    const existingDrawer = document.body.querySelector(":scope > .menu-drawer");
    const existingOverlay = existingDrawer?.nextElementSibling;

    if (existingDrawer) {
      existingDrawer.remove();
      existingOverlay?.remove();
    }

    if (this.headerMenuDrawerMarkup) {
      const clonedContent = this.headerMenuDrawerMarkup.content.cloneNode(true);

      const clonedDrawer = clonedContent.querySelector("menu-drawer");
      const clonedOverlay = clonedDrawer.nextElementSibling;

      document.body.insertAdjacentElement("beforeend", clonedDrawer);
      document.body.insertAdjacentElement("beforeend", clonedOverlay);

      const drawer = document.getElementById("HeaderMenu");

      if (window.isHeaderDrawerMenuOpen) {
        drawer.open();
      }

      const mutationObserver = new MutationObserver(() => {
        window.isHeaderDrawerMenuOpen = !!drawer.classList.contains("open");
      });

      mutationObserver.observe(drawer, {
        attributes: true,
        childList: false,
        subtree: false
      });
    }
  }

  hideMenuDrawerOnDesktop() {
    document.addEventListener("breakpoint:sm:match", () => {
      document.getElementById("HeaderMenu")?.close();
    });
  }

  handleStickyHeader() {
    if (!this.settings.enableStickyHeader) {
      return;
    }

    const scrollTop = window.scrollY;
    const announcementBarHeight = this.announcementBar?.offsetHeight || 0;

    if (scrollTop > announcementBarHeight) {
      this.headerSection.classList.add("header-scrolled");
    } else {
      this.headerSection.classList.remove("header-scrolled");
    }

    if (scrollTop > this.headerBounds.bottom + 60) {
      if (scrollTop >= this.currentScrollTop) {
        this.headerSection.classList.add("header-hidden");
      } else {
        this.headerSection.classList.remove("header-hidden");
      }
    } else {
      this.headerSection.classList.remove("header-hidden");
    }

    this.currentScrollTop = scrollTop;
  }
}

if (!window.customElements.get("header-section")) {
  customElements.define("header-section", HeaderSection, { extends: "header" });
}


class FooterBlocksParallax extends HTMLDivElement {
  constructor() {
    super();

    this.blocks = this.querySelectorAll(".footer__blocks--desktop .footer-block");
    this.logos = this.querySelectorAll(".footer__blocks--desktop .footer-block--logo :is(img, svg)");

    if (theme.params.isMotionReduced) {
      return;
    }

    this.initParallax();

    document.addEventListener("breakpoint:sm:match", this.unload.bind(this));
    document.addEventListener("breakpoint:sm:unmatch", this.initParallax.bind(this));

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:unload", () => {
        this.resetAnimation();
      });
    }
  }

  initParallax() {
    if (!this.logos.length || !this.blocks.length) {
      return;
    }

    const animations = [];

    this.blocks.forEach((block) => {
      animations.push(
        Motion.scroll(
          Motion.animate(block, {
            transform: ["translateY(100px)", "translateY(0)"]
          }), {
            target: this,
            offset: [
              [0, 1], [1, 1]
            ]
          })
      );
    });

    setTimeout(() => {
      this.logos.forEach((logo) => {
        animations.push(
          Motion.scroll(
            Motion.animate(logo, {
              transform: ["scale(0)", "scale(1)"]
            }), {
              target: this,
              offset: [
                [0, 1], [1, 1]
              ]
            })
        );
      });

      this.animations = animations;
    });
  }

  resetAnimation() {
    if (theme.params.isMotionReduced || (this.mobileEnabled && (theme.params.isTouchDevice || theme.config.isSmallQuery))) {
      return;
    }

    setTimeout(() => {
      this.blocks.forEach((block) => {
        Motion.animate(block, {
          transform: "translateY(0)"
        }, {
          duration: 0
        });
      });

      this.logos.forEach((logo) => {
        Motion.animate(logo, {
          transform: "scale(1)"
        }, {
          duration: 0
        });
      });
    });
  }

  unload() {
    setTimeout(() => {
      this.animations?.forEach((animation) => {
        animation();
      });

      this.blocks.forEach((block) => {
        Motion.animate(block, {
          transform: "translateY(0)"
        }, {
          duration: 0
        });
      });

      this.logos.forEach((logo) => {
        Motion.animate(logo, {
          transform: "scale(1)"
        }, {
          duration: 0
        });
      });
    });
  }
}

if (!window.customElements.get("footer-blocks-parallax")) {
  customElements.define("footer-blocks-parallax", FooterBlocksParallax, { extends: "div" });
}


class FooterGroup extends HTMLElement {
  constructor() {
    super();

    this.footer = this.querySelector(".footer");

    if (!this.footer) {
      return;
    }

    this.initFooterFollowOnShop();

    document.addEventListener("breakpoint:sm:match", this.moveFollowOnShopToCurrentScreen.bind(this));
    document.addEventListener("breakpoint:sm:unmatch", this.moveFollowOnShopToCurrentScreen.bind(this));
  }

  initFooterFollowOnShop() {
    if (!this.footer) {
      return;
    }

    this.followOnShopDesktopBlock = this.footer.querySelector(".footer__blocks--desktop .follow-on-shop-block");
    this.followOnShopMobileBlock = this.footer.querySelector(".footer__blocks--mobile .follow-on-shop-block");
    this.followOnShopDesktop = this.footer.querySelector(".footer__blocks--desktop .follow-on-shop");
    this.followOnShopMobile = this.footer.querySelector(".footer__blocks--mobile .follow-on-shop");

    if (this.followOnShopDesktop) {
      if (theme.config.isSmallQuery) {
        this.followOnShopPrimary = this.followOnShopMobile;
        this.followOnShopDesktop.remove();
      } else {
        this.followOnShopPrimary = this.followOnShopDesktop;
        this.followOnShopMobile.remove();
      }

      this.moveFollowOnShopToCurrentScreen();
    }
  }

  moveFollowOnShopToCurrentScreen() {
    if (theme.config.isSmallQuery) {
      const hasButtonAlready = this.footer.querySelector(".footer__blocks--mobile .follow-on-shop");

      if (hasButtonAlready) {
        return;
      }

      if (this.followOnShopPrimary === this.followOnShopDesktop) {
        this.followOnShopMobileBlock.insertAdjacentElement("beforeend", this.followOnShopDesktop);
        this.followOnShopMobile = this.footer.querySelector(".footer__blocks--mobile .follow-on-shop");
      }
    } else {
      const hasButtonAlready = this.footer.querySelector(".footer__blocks--desktop .follow-on-shop");

      if (hasButtonAlready) {
        return;
      }

      if (this.followOnShopPrimary === this.followOnShopMobile) {
        this.followOnShopDesktopBlock.insertAdjacentElement("beforeend", this.followOnShopMobile);
        this.followOnShopDesktop = this.footer.querySelector(".footer__blocks--desktop .follow-on-shop");
      }
    }
  }
}

if (!window.customElements.get("footer-group")) {
  customElements.define("footer-group", FooterGroup);
}


class SwatchDropdown extends HTMLElement {
  constructor() {
    super();

    this.spanFor = this.dataset.spanFor;
    this.dropdown = this.parentElement.querySelector(".select-custom__inner");

    if (this.spanFor) {
      this.addEventListener("click", this.activeFilterSort.bind(this), false);
    }

    this.setDropdownHeight();
  }

  setDropdownHeight() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === this.dropdown) {
          this.parentElement.style.setProperty("--dropdown-height", `${entry.target.getBoundingClientRect().height}px`);
        }
      }
    });

    resizeObserver.observe(this.dropdown);
  }

  activeFilterSort() {
    const spanBlock = this.querySelector(`#${this.spanFor}`);

    if (!spanBlock) {
      return;
    }

    if (spanBlock.classList.contains("active")) {
      spanBlock.classList.remove("active");
    } else {
      spanBlock.classList.add("active");
    }
  }
}

if (!window.customElements.get("swatch-dropdown")) {
  customElements.define("swatch-dropdown", SwatchDropdown);
}


class ProductTiers extends HTMLElement {
  constructor() {
    super();

    this.formId = this.dataset.form;
    this.priceDisplayType = this.dataset.priceDisplayType;
    this.currentPrice = parseInt(this.dataset.mainPrice, 10) || 0;
    this.saveBadgeFormat = this.dataset.saveBadgeFormat;
    this.saveBadgeTemplate = this.dataset.saveBadgeTemplate;
    this.form = document.forms[this.formId];
    this.tiers = this.querySelectorAll(".product-tier");

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
    this.handleVariantControlClickListener = this.handleVariantControlClick.bind(this);
    this.handleTierChangeListener = this.handleTierChange.bind(this);
    this.handleSubmitListener = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
    this.form?.addEventListener("submit", this.handleSubmitListener, { capture: true });
    this.addEventListener("click", this.handleVariantControlClickListener);
    this.addEventListener("change", this.handleVariantControlClickListener);
    this.addEventListener("change", this.handleTierChangeListener);

    this.updateVisibleUnits();
    this.updateSummary();
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
    this.form?.removeEventListener("submit", this.handleSubmitListener, { capture: true });
    this.removeEventListener("click", this.handleVariantControlClickListener);
    this.removeEventListener("change", this.handleVariantControlClickListener);
    this.removeEventListener("change", this.handleTierChangeListener);
  }

  getCheckedTierQuantity() {
    const checkedRadio = this.querySelector(".product-tier__radio:checked");

    return parseInt(checkedRadio?.closest(".product-tier")?.dataset.tierQuantity, 10) || 1;
  }

  // The shared swatches area is only worth showing once a tier needing
  // more than one pick is selected — quantity 1 is already covered by
  // the page's own variant picker shown elsewhere on the page, so a
  // second control for that same single choice would just be
  // redundant. Picking a tier with quantity > 1 reveals it plus one row
  // per unit (e.g. "2x" → rows 0 and 1) so a different value can be
  // chosen per unit.
  handleTierChange(event) {
    if (!event.target.classList.contains("product-tier__radio")) return;

    this.updateVisibleUnits();
    this.updateSummary();
  }

  // Raw discount math shared between the per-card price columns
  // (handleVariantChange) and the block-level summary row — kept as one
  // function so the two never drift apart.
  calculateTierPrices(price, quantity, discountType, discountValue) {
    let singleDiscountedPrice;

    if (discountType === "fixed") {
      singleDiscountedPrice = Math.max(0, Math.ceil(price - discountValue * 100));
    } else {
      singleDiscountedPrice = Math.ceil(price - price * (discountValue / 100));
    }

    return {
      singleDiscountedPrice,
      totalDiscountedPrice: singleDiscountedPrice * quantity,
      totalPrice: price * quantity,
    };
  }

  // Mirrors whichever tier is currently checked: the first tier is
  // always the plain, undiscounted base price (see the price-column
  // comment in snippets/product-tiers.liquid), so only tiers after it
  // ever show a struck-through original price next to the final one.
  updateSummary() {
    const summaryPrice = this.querySelector("[data-summary-price]");
    const summaryCompare = this.querySelector("[data-summary-compare]");

    if (!summaryPrice || !summaryCompare) return;

    const checkedRadio = this.querySelector(".product-tier__radio:checked");
    const checkedTier = checkedRadio?.closest(".product-tier");
    const tierIndex = Array.from(this.tiers).indexOf(checkedTier);

    if (tierIndex <= 0) {
      summaryPrice.innerText = Shopify.formatMoney(this.currentPrice, window.settings.moneyFormat);
      summaryPrice.classList.remove("color-sale-price-product-card");
      summaryPrice.classList.add("color-price-product-card");
      summaryCompare.innerText = "";
      summaryCompare.hidden = true;

      return;
    }

    const settings = theme.helpers.safelyParseJson(checkedTier.dataset.tierSettings) || {};
    const quantity = parseInt(settings.quantity) || 1;
    const discountValue = parseFloat(settings.discountValue) || 0;

    const { totalDiscountedPrice, totalPrice } = this.calculateTierPrices(
      this.currentPrice,
      quantity,
      settings.discountType,
      discountValue
    );

    summaryPrice.innerText = Shopify.formatMoney(totalDiscountedPrice, window.settings.moneyFormat);
    summaryPrice.classList.remove("color-price-product-card");
    summaryPrice.classList.add("color-sale-price-product-card");
    summaryCompare.innerText = Shopify.formatMoney(totalPrice, window.settings.moneyFormat);
    summaryCompare.hidden = false;
  }

  updateVisibleUnits() {
    const quantity = this.getCheckedTierQuantity();
    const shared = this.querySelector("[data-shared-variants]");

    if (shared) shared.hidden = quantity <= 1;

    this.querySelectorAll("[data-shared-variants] .product-tier__unit").forEach((unit) => {
      const index = parseInt(unit.dataset.unitIndex, 10) || 0;

      unit.hidden = index >= quantity;
    });
  }

  // Every visible row here is its own independent pick (a different
  // value per unit) — toggled locally and read back at Add to cart time
  // in handleSubmit. Nothing to forward anywhere else: the shared area
  // is hidden whenever there'd only be one row to show (see
  // updateVisibleUnits), which is the only case that would overlap with
  // the page's real variant picker.
  handleVariantControlClick(event) {
    const control = event.target.closest("[data-option-name]");

    if (!control || control.disabled) return;

    const unit = control.closest(".product-tier__unit");

    unit?.querySelectorAll("[data-option-value]").forEach((button) => {
      button.classList.toggle("is-active", button === control);
    });

    const optionLabel = unit?.querySelector("[data-unit-option]");
    const optionValue = control.tagName === "SELECT" ? control.value : control.dataset.optionValue;

    if (optionLabel) {
      optionLabel.innerText = ` - ${control.dataset.optionName}: ${optionValue}`;
    }
  }

  getCart() {
    return document.querySelector("cart-page, cart-drawer");
  }

  // Shopify can't vary the variant within a single line item's quantity,
  // so a selected tier with quantity > 1 (independent per-unit picks,
  // see handleVariantControlClick) can't go through the native
  // id+quantity submit at all — it's sent as one /cart/add.js call with
  // N separate { id, quantity: 1 } items instead, mirroring
  // assets/product-bundle-builder.js's own cart-add path so the post-add
  // UX (cart drawer refresh, events) matches everywhere else. A
  // quantity-1 tier has nothing to gather here and submits natively.
  handleSubmit(event) {
    const tierQuantity = this.getCheckedTierQuantity();
    const units = this.querySelectorAll("[data-shared-variants] .product-tier__unit:not([hidden])");

    // No per-unit rows at all (product has no real variant options) —
    // nothing to differentiate per unit, so leave this to the native
    // id+quantity submit exactly as before this feature existed.
    if (tierQuantity <= 1 || !this.form || units.length === 0) return;

    const currentVariantId = new FormData(this.form).get("id");

    const variantIds = Array.from(units).map((unit) => {
      const select = unit.querySelector("select[data-option-name]");

      if (select) {
        const selectedOption = select.selectedOptions[0];

        return selectedOption ? parseInt(selectedOption.dataset.variantId, 10) : parseInt(currentVariantId, 10);
      }

      const active = unit.querySelector("[data-option-value].is-active");

      return active ? parseInt(active.dataset.variantId, 10) : parseInt(currentVariantId, 10);
    });

    if (variantIds.some((id) => !id)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitButton = this.form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.setAttribute("aria-disabled", "true");
      submitButton.classList.add("loading");
    }

    const cart = this.getCart();

    const body = {
      items: variantIds.map((id) => ({ id, quantity: 1 })),
    };

    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((section) => section.name);
      body.sections_url = window.location.pathname;
    }

    if (cart) cart.classList.add("loading");

    fetch(window.routes.cartAddUrl, {
      ...theme.helpers.fetchConfig(),
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.dispatchEvent(new CustomEvent("theme:product:error", {
            detail: {
              productVariantId: variantIds[0],
              errors: response.errors || response.description,
              message: response.message,
            },
          }));

          return;
        }

        fetch(`${window.routes.cartUrl}.json`)
          .then((res) => res.json())
          .then((cartData) => {
            document.dispatchEvent(new CustomEvent("theme:cart:count:update", {
              detail: { count: cartData.item_count },
            }));

            const freeShippingBar = document.querySelector("free-shipping-bar");

            if (freeShippingBar) freeShippingBar.init(cartData.items_subtotal_price);
          })
          .catch((error) => { throw error; });

        document.dispatchEvent(new CustomEvent("theme:product:added", {
          detail: { productVariantId: variantIds[0] },
        }));

        if (cart && response.sections) {
          cart.getSectionsToRender().forEach((sectionInfo) => {
            const html = new DOMParser().parseFromString(response.sections[sectionInfo.name], "text/html");
            const currentSection = document.getElementById(sectionInfo.id).querySelector("#cart-drawer-form");

            if (!currentSection) return;

            const currentProducts = currentSection.querySelector(".cart-drawer__products");
            const currentFooter = currentSection.querySelector(".cart-drawer__footer");
            const parsedProducts = html.querySelector(".cart-drawer__products");
            const parsedFooter = html.querySelector(".cart-drawer__footer");

            if (currentFooter && parsedFooter) {
              currentProducts.replaceChildren(document.createRange().createContextualFragment(parsedProducts.innerHTML));
              currentFooter.replaceChildren(document.createRange().createContextualFragment(parsedFooter.innerHTML));
            } else {
              currentSection.innerHTML = html.querySelector("#cart-drawer-form").innerHTML;
            }
          });

          if (cart.initCartActions) cart.initCartActions();
          if (cart.classList.contains("is-empty")) cart.classList.remove("is-empty");
          if (cart.open) cart.open(submitButton);
        } else if (!cart) {
          window.location = window.routes.cartUrl;
        }
      })
      .catch(() => {
        document.dispatchEvent(new CustomEvent("theme:product:error", {
          detail: {
            productVariantId: variantIds[0],
            message: window.cartStrings ? window.cartStrings.error : "Something went wrong, please try again.",
          },
        }));
      })
      .finally(() => {
        if (submitButton) {
          submitButton.removeAttribute("aria-disabled");
          submitButton.classList.remove("loading");
        }

        if (cart) cart.classList.remove("loading");
      });
  }

  handleVariantChange(e) {
    const variant = e.detail.variant;

    if (!variant || !variant.available) {
      this.classList.add("!hidden");

      return;
    }

    const price = variant.price;
    const priceMoney = Shopify.formatMoney(price, window.settings.moneyFormat);

    this.currentPrice = price;

    this.tiers.forEach((tier, index) => {
      const settings = theme.helpers.safelyParseJson(tier.dataset.tierSettings) || {};

      const quantity = parseInt(settings.quantity) || 1;
      const discountValue = parseFloat(settings.discountValue) || 0;

      const { singleDiscountedPrice, totalDiscountedPrice, totalPrice } = this.calculateTierPrices(
        price,
        quantity,
        settings.discountType,
        discountValue
      );

      const singleDiscountedPriceMoney = Shopify.formatMoney(singleDiscountedPrice, window.settings.moneyFormat);
      const totalDiscountedPriceMoney = Shopify.formatMoney(totalDiscountedPrice, window.settings.moneyFormat);
      const totalPriceMoney = Shopify.formatMoney(totalPrice, window.settings.moneyFormat);

      const priceValueBlock = tier.querySelector("[data-price-value]");
      const priceCompareValueBlock = tier.querySelector("[data-price-compare-value]");

      if (index === 0) {
        priceValueBlock.innerText = priceMoney;
      } else {
        if (this.priceDisplayType === "per-unit") {
          priceValueBlock.innerText = singleDiscountedPriceMoney;
          if (priceCompareValueBlock) priceCompareValueBlock.innerText = priceMoney;
        } else {
          priceValueBlock.innerText = totalDiscountedPriceMoney;
          if (priceCompareValueBlock) priceCompareValueBlock.innerText = totalPriceMoney;
        }

        // The percentage badge is static (doesn't depend on price), so
        // only the "Save €X" format needs live updates here as the
        // price itself changes with the variant.
        if (this.saveBadgeFormat === "amount" && this.saveBadgeTemplate) {
          const saveBadge = tier.querySelector(".product-bundle-builder__card-discount-percent");

          if (saveBadge) {
            const saved = this.priceDisplayType === "per-unit"
              ? price - singleDiscountedPrice
              : totalPrice - totalDiscountedPrice;

            const savedMoney = Shopify.formatMoney(Math.max(0, saved), window.settings.moneyFormat);

            saveBadge.innerText = this.saveBadgeTemplate.replace("[amount]", savedMoney);
          }
        }
      }
    });

    // Every card shows the same product, so a single variant change
    // updates all of them the same way: the shared image, and (if a
    // swatch/button row is rendered) which value looks selected.
    const image = variant.featured_image && variant.featured_image.src;

    if (image) {
      this.querySelectorAll(".product-bundle-builder__card-media img").forEach((img) => {
        img.src = image;
      });
    }

    this.syncSharedVariantSelection(variant);
    this.updateSummary();
    this.classList.remove("!hidden");
  }

  // Keeps every unit row's own control (swatch/button/select) and label
  // in sync when the variant changes from OUTSIDE this component — e.g.
  // the page's own main variant picker. The reverse direction (a pick
  // made here affecting the main picker) is intentionally not wired —
  // each unit is its own independent pick once quantity > 1, so there's
  // no single "the" selection to push back up.
  syncSharedVariantSelection(variant) {
    this.querySelectorAll(".product-tier__unit").forEach((unit) => {
      let activeValue = null;
      let optionName = null;

      const select = unit.querySelector("select[data-option-name]");

      if (select) {
        const matchedOption = Array.from(select.options).find(
          (option) => parseInt(option.dataset.variantId, 10) === variant.id
        );

        if (matchedOption) {
          select.value = matchedOption.value;
          activeValue = matchedOption.value;
          optionName = select.dataset.optionName;
        }
      } else {
        unit.querySelectorAll("[data-option-value]").forEach((control) => {
          const isMatch = parseInt(control.dataset.variantId, 10) === variant.id;

          control.classList.toggle("is-active", isMatch);

          if (isMatch) {
            activeValue = control.dataset.optionValue;
            optionName = control.dataset.optionName;
          }
        });
      }

      if (activeValue !== null) {
        const optionLabel = unit.querySelector("[data-unit-option]");

        if (optionLabel) optionLabel.innerText = ` - ${optionName}: ${activeValue}`;
      }
    });
  }
}

if (!window.customElements.get("product-tiers")) {
  customElements.define("product-tiers", ProductTiers);
}


class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".product-tabs__tab");
    this.productBlocks = this.querySelectorAll(".product-tabs__blocks");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (evt) => {
        evt.preventDefault();

        const blockId = tab.dataset.blockId;

        this.showContent(blockId);

        this.tabs.forEach((innerTab) => {
          innerTab.classList.remove("underline");
          innerTab.removeAttribute("disabled");
        });

        tab.classList.add("underline");
        tab.setAttribute("disabled", "disabled");
      });
    });
  }

  showContent(blockId) {
    this.productBlocks.forEach((productBlock) => {
      productBlock.classList.add("product-tabs__blocks--refreshing");

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("product-tabs__blocks--hidden");
        } else {
          productBlock.classList.add("product-tabs__blocks--hidden");
        }

        productBlock.classList.add("animated-blocks--hide-instantly");
        productBlock.classList.remove("visible");
        productBlock.classList.remove("product-tabs__blocks--refreshing");
      }, 300);

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("animated-blocks--hide-instantly");
          productBlock.classList.add("visible");
        }
      }, 500);
    });
  }
}

if (!window.customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}


class GeoShippingNotice extends HTMLElement {
  constructor() {
    super();

    this.settings = theme.helpers.safelyParseJson(this.getAttribute("settings"));
    this.message = this.querySelector(".geo-shipping-notice__message");
    this.cacheKey = "geoShippingCountry";

    this.init();
  }

  init() {
    if (!this.message || !this.settings) {
      return;
    }

    const excluded = this.settings.excludedCountries.split(",").map((c) => c.trim().toUpperCase());
    const cached = this.getCached();

    if (cached) {
      this.renderMessage(excluded, cached.country, cached.code);

      return;
    }

    fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`)
      .then((res) => res.json())
      .then((data) => {
        const country = data.detected_values?.country?.name || "your country";
        const code = data.detected_values?.country?.handle?.toUpperCase() || "";

        this.setCached(country, code);
        this.renderMessage(excluded, country, code);

        this.classList.remove("invisible");
      })
      .catch(() => {
        this.message.innerText = "Unable to detect location.";

        this.classList.add("!hidden");
      });
  }

  renderMessage(excluded, country, code) {
    const flag = code ? String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt())) : "🌐";
    const isExcluded = excluded.includes(code);
    const template = isExcluded ? this.settings.messageUnsupported : this.settings.messageSupported;

    this.message.innerHTML = template.replace("[country]", country).replace("[flag]", flag);

    this.classList.remove("invisible");
  };

  getCached() {
    const oneDay = 24 * 60 * 60 * 1000;

    try {
      const cached = JSON.parse(localStorage.getItem(this.cacheKey));

      if (cached && Date.now() - cached.timestamp < oneDay) {
        return cached;
      }
    } catch {}

    localStorage.removeItem(this.cacheKey);

    return null;
  };

  setCached(country, code) {
    localStorage.setItem(this.cacheKey, JSON.stringify({
      country,
      code,
      timestamp: Date.now()
    }));
  };
}

if (!window.customElements.get("geo-shipping-notice")) {
  customElements.define("geo-shipping-notice", GeoShippingNotice);
}


class StickyAtcBar extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.section = document.querySelector(`.product-section[data-section-id="${this.sectionId}"]`);
    this.position = this.dataset.position;
    this.select = this.querySelector(".sticky-atc-bar__select");
    this.image = this.querySelector(".sticky-atc-bar__image img");
    this.atcButton = this.section.querySelector(".product-form__buy-button");
    this.mainForm = this.atcButton.closest("form");
    this.mainVariants = this.section.querySelectorAll("variant-radios-detail fieldset");
    this.variantsData = this.querySelector(".product-variants-json");
    this.variantsJSON = this.variantsData ? JSON.parse(this.variantsData.textContent) : [];
    this.form = this.querySelector("form");
    this.quantityInputs = [this.querySelector("input[name='quantity']"), this.section.querySelector("input[name='quantity']")];

    this.buttonRect = null;

    // ✅ riferimento al bottone sticky
    this.stickyButton = this.form?.querySelector('button[name="add"]');

    this.init();

    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
    this.handleSelectChangeListener = this.handleSelectChange.bind(this);
  }

  init() {
    this.moveOutsideSection();
    this.setInitialPosition();
    this.observeAtcButton();
    this.handleScroll();
    this.syncQuantityInputs();
    this.setBarHeight();

    // ✅ stato iniziale bottone sticky
    const currentId = this.querySelector('[name="id"]')?.value;
    if (currentId) {
      const v = this.getVariantDataById(+currentId);
      this.applyButtonState(v);
    }
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScrollListener, { passive: true });
    this.mainForm?.addEventListener("variant:change", this.handleVariantChangeListener);
    this.select?.addEventListener("change", this.handleSelectChangeListener);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScrollListener);
    this.mainForm?.removeEventListener("variant:change", this.handleVariantChangeListener);
    this.select?.removeEventListener("change", this.handleSelectChangeListener);
  }

  setBarHeight() {
    document.documentElement.style.setProperty("--sticky-bar-height", `${this.getBoundingClientRect().height}px`);

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === this) {
          document.documentElement.style.setProperty("--sticky-bar-height", `${entry.target.getBoundingClientRect().height}px`);
        }
      }
    });

    resizeObserver.observe(this);
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    if (variant) {
      const element = this.querySelector('[name="id"]');

      element.value = variant.id;
      element.dispatchEvent(new Event("change", { bubbles: true }));

      this.select.value = variant.id;

      this.form.dispatchEvent(new CustomEvent("variant:change", {
        detail: { variant: variant }
      }));

      // ✅ aggiorna stato bottone sticky
      const vData = this.getVariantDataFromShopifyVariant(variant);
      this.applyButtonState(vData);
    }
  }

  handleSelectChange() {
    const option = this.select.options[this.select.selectedIndex];
    const imageSrc = option.dataset.image;
    const variantId = +this.select.value;
    const variant = this.variantsJSON.find((variant) => variant.id === variantId);

    const element = this.querySelector('[name="id"]');
    element.value = variantId;
    element.dispatchEvent(new Event("change", { bubbles: true }));

    this.mainVariants.forEach((fieldset, index) => {
      const optVal = variant[`option${index + 1}`];
      const select = fieldset.querySelector("select");
      const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(optVal)}"]`);

      if (select) {
        select.value = optVal;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      } else if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    if (this.image && imageSrc) {
      this.image.src = imageSrc;
      this.image.removeAttribute("srcset");
    }

    // ✅ aggiorna stato bottone sticky
    this.applyButtonState(variant);
  }

  syncQuantityInputs() {
    this.quantityInputs.forEach((input) => {
      input?.addEventListener("change", () => {
        const value = +input.value;
        this.quantityInputs.forEach((otherInput) => {
          if (otherInput && otherInput !== input) {
            otherInput.value = value;
          }
        });
      });
    });
  }

  moveOutsideSection() {
    const existingStickyBar = document.querySelector("body > .sticky-atc-bar");
    existingStickyBar?.remove();
    document.body.appendChild(this);
  }

  setInitialPosition() {
    this.buttonRect = this.atcButton.getBoundingClientRect();
    this.buttonTopOffset = this.atcButton.getBoundingClientRect().top + window.scrollY;
  }

  handleScroll() {
    const scrollY = window.scrollY;
    if (!this.buttonRect) return;

    const isAbove = scrollY > this.buttonTopOffset + this.atcButton.offsetHeight;
    if (isAbove) {
      this.showSticky();
    } else {
      this.hideSticky();
    }
  }

  observeAtcButton() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.setInitialPosition();
          if (entry.isIntersecting) this.hideSticky();
        });
      },
      { root: null, threshold: 0 }
    );
    observer.observe(this.atcButton);
  }

  showSticky() {
    this.classList.add("visible");
    document.body.classList.add("sticky-atc-bar-visible");
    document.body.classList.add(`sticky-atc-bar-position-${this.position}`);
  }

  hideSticky() {
    this.classList.remove("visible");
    document.body.classList.remove("sticky-atc-bar-visible");
  }

  // ==========================
  // ✅ NUOVI METODI
  // ==========================
  getVariantDataById(id) {
    return this.variantsJSON.find(v => v.id === id);
  }

  getVariantDataFromShopifyVariant(v) {
    return this.getVariantDataById(+v.id) || {
      id: +v.id,
      available: !!v.available,
      qty: Number(v.inventory_quantity || 0),
      management: v.inventory_management || ''
    };
  }

  setStickyDisabled(state) {
    if (!this.stickyButton) return;
    if (state) {
      this.stickyButton.setAttribute('disabled', 'disabled');
      this.stickyButton.setAttribute('aria-disabled', 'true');
    } else {
      const fs = this.stickyButton.closest('fieldset[disabled]');
      if (fs) fs.disabled = false;
      this.stickyButton.removeAttribute('disabled');
      this.stickyButton.setAttribute('aria-disabled', 'false');
    }
  }

  applyButtonState(variant) {
    if (!this.stickyButton || !variant) return;

    const tAdd  = "{{ 'product.add_to_cart' | t }}";
    const tPre  = "{{ 'product.pre_order'   | t }}";
    const tSold = "{{ 'product.sold_out'    | t }}";

    if (variant.available === false) {
      this.setStickyDisabled(true);
      this.stickyButton.setAttribute('aria-label', tSold);
      return;
    }

    const managed = !!(variant.management && variant.management !== 'null' && variant.management !== 'undefined');
    const qty = Number(variant.qty || 0);

    if (managed && qty < 1) {
      this.setStickyDisabled(false);
      this.stickyButton.setAttribute('aria-label', tPre);
    } else {
      this.setStickyDisabled(false);
      this.stickyButton.setAttribute('aria-label', tAdd);
    }
  }
}

if (!window.customElements.get("sticky-atc-bar")) {
  customElements.define("sticky-atc-bar", StickyAtcBar);
}



class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest(".product-section");
    this.layout = this.dataset.layout;
    this.enableAltFiltering = this.hasAttribute("data-enable-alt-filtering");
    this.productSlider = this.querySelector("slide-with-thumbs");
    this.productDataJSON = this.section.querySelector(".productJson");
    this.productData = this.productDataJSON ? JSON.parse(this.productDataJSON.textContent) : [];
    this.circleText = this.querySelector(".circle-text-wrapper");
    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];
    this.filteredIndexes = theme.helpers.safelyParseJson(this.dataset.filteredIndexes) || {};

    this.init();

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);

    document.addEventListener("breakpoint:sm:match", this.unloadCircleAnimation.bind(this));
    document.addEventListener("breakpoint:sm:unmatch", this.loadCircleAnimation.bind(this));
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  init() {
    this.loadCircleAnimation();

    if (this.enableAltFiltering) {
      this.saveSliderSlides();
    }
  }

  saveSliderSlides() {
    if (!this.productSlider) {
      return;
    }

    const swiperSlider = this.productSlider.querySelector(".product-slider");

    if (!swiperSlider) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (!swiperSlider.classList.contains("swiper-initialized")) {
        return;
      }

      this.originalSlides = Array.from(this.productSlider?.globalSlide.slides).map((slide) => {
        const newSlide = slide.cloneNode(true);
        const images = newSlide.querySelectorAll(".fade-in-image");

        images.forEach((image) => {
          image.classList.remove("fade-in-image");
        });

        return newSlide.outerHTML;
      });

      this.originalThumbnailSlides = Array.from(this.productSlider?.thumbnailSlide.slides).map((slide) => {
        const newSlide = slide.cloneNode(true);
        const images = newSlide.querySelectorAll(".fade-in-image");

        images.forEach((image) => {
          image.classList.remove("fade-in-image");
        });

        return newSlide.outerHTML;
      });

      this.filteredIndexes = this.filteredIndexes.map((index) => {
        return index - 1;
      });

      this.filterMediaByAlt(this.filteredIndexes);

      observer.disconnect();
    });

    observer.observe(swiperSlider, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    if (!variant) {
      return;
    }

    if (this.enableAltFiltering) {
      const filteredIndexes = this.getHiddenMediaIndexes(this.productData, variant);

      this.filterMediaByAlt(filteredIndexes);
    }
  }

  filterMediaByAlt(filteredIndexes) {
    if (this.layout === "grid") {
      this.medias = this.querySelectorAll(".media-gallery__video, .media-gallery__model, .media-gallery__image");

      this.medias.forEach((media, index) => {
        media.classList.remove("!hidden");
      });

      filteredIndexes.forEach((index) => {
        const media = this.medias[index];

        if (media) {
          media.classList.add("!hidden");
        }
      });
    } else if (this.layout === "carousel") {
      let firstThumbnailIndex = -1;
      this.productSlider?.thumbnailSlide.slides.forEach((slide, index) => {
        if (firstThumbnailIndex === -1 && !filteredIndexes.includes(index)) {
          firstThumbnailIndex = index;
        }
      });

      this.productSlider?.globalSlide.removeAllSlides();
      this.productSlider?.thumbnailSlide.removeAllSlides();
      this.productSlider?.globalSlide.appendSlide(this.originalSlides);
      this.productSlider?.thumbnailSlide.appendSlide(this.originalThumbnailSlides);

      this.productSlider?.globalSlide.removeSlide(filteredIndexes);
      this.productSlider?.thumbnailSlide.removeSlide(filteredIndexes);

      this.productSlider?.globalSlide.update();
      this.productSlider?.globalSlide.slideTo(0);

      document.dispatchEvent(new CustomEvent("theme:images:lazy-load"));
      document.dispatchEvent(new CustomEvent("theme:zoom:init"));
    }
  }

  getHiddenMediaIndexes(product, variant) {
    const filteredMediaIndexes = [];

    product.media.forEach((media, index) => {
      const alt = media.alt;
      const isFeatured = variant.featured_media && media.position === variant.featured_media.position;

      if (!alt || !alt.includes("#") || alt === product.title || isFeatured) {
        return;
      }

      const altParts = alt.split("#");
      const filterString = altParts[1].trim();
      const optionPairs = filterString.split("_");

      let shouldHide = false;

      for (const pair of optionPairs) {
        if (!pair.includes("=")) {
          continue;
        }
        
        const [rawOptionName, rawValues] = pair.split("=");
        let rawOptionNameIT = rawOptionName;
        const locale = document.documentElement.lang;
        if (locale === 'it') {
          rawOptionNameIT = 'Colore';
        }

        const optionName = rawOptionNameIT.trim().toLowerCase();
        const expectedValues = rawValues.trim().toLowerCase().split(",");

        const optionIndex = product.options.findIndex((optName) => {
          return optName.toLowerCase() === optionName;
        });

        if (optionIndex !== -1) {
          const selectedValue = variant.options[optionIndex]?.toLowerCase();

          if (!expectedValues.includes(selectedValue)) {
            shouldHide = true;

            break;
          }
        }
      }

      if (shouldHide) {
        filteredMediaIndexes.push(index);
      }
    });

    return filteredMediaIndexes;
  }

  loadCircleAnimation() {
    if (theme.params.isMotionReduced || theme.config.isSmallQuery || !this.circleText) {
      return;
    }

    const animations = [];

    animations.push(
      Motion.scroll(
        Motion.animate(this.circleText, {
          transform: ["rotate(90deg)", "rotate(270deg)"]
        }), {
          target: this,
          offset: [
            [0, 1], [1, 0]
          ]
        })
    );

    this.circleAnimations = animations;
  }

  unloadCircleAnimation() {
    setTimeout(() => {
      if (!this.circleText) {
        return;
      }

      this.circleAnimations.forEach((animation) => {
        animation();
      });

      Motion.animate(this.circleText, {
        transform: "rotate(0deg)"
      }, {
        duration: 0
      });
    });
  }
}

if (!window.customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}


class SwatchInit extends HTMLElement {
  constructor() {
    super();

    this.options = null;
    this.swatches = this.querySelectorAll(".product__color-swatch-option");

    this.swatches.forEach((swatch) => {
      this.checkSwatches(swatch);
    });
  }

  checkSwatches(swatch) {
    const { color, image, customValue, swatchType } = swatch.dataset;

    if (!color) {
      return;
    }

    if (swatchType === "variant-image") {
      if (image) {
        if (!color.includes("rgb(")) {
          swatch.classList.add(`color__${color.replace(" ", "-")}`);
        }

        swatch.style.backgroundColor = null;
        swatch.style.backgroundImage = `url(${image})`;
        swatch.style.backgroundSize = "cover";
        swatch.style.backgroundRepeat = "no-repeat";
      } else if (this.checkColor(color)) {
        swatch.style.backgroundColor = color;

        swatch.classList.add(customValue);
      } else {
        swatch.classList.add(customValue);
      }
    } else if (swatchType === "swatches") {
      swatch.classList.add(customValue);

      if (this.checkColor(color)) {
        swatch.style.backgroundColor = color;
      } else {
        swatch.classList.add(customValue);
      }
    } else {
      swatch.classList.add(customValue);
    }
  }

  checkColor(color) {
    const optionStyle = new Option().style;

    optionStyle.color = color;

    return optionStyle.color === color;
  }

  updateOptions() {
    const activeOptions = this.querySelectorAll(".product__color-swatch-option.active");

    this.options = Array.from(activeOptions, (select) => {
      return select.getAttribute("data-value");
    });

    this.variantData.find((variant) => {
      if (this.options.length === 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };

        if (variantOptions[this.swatchPosition] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }

  updateMasterId(variantData) {
    this.currentVariant = variantData.find((variant) => {
      return variant.options.every((option, index) => {
        return this.options[index] === option;
      })
    });

    return this.currentVariant;
  }
}


class SwatchFunctions extends SwatchInit {
  constructor() {
    super();

    this.updateVariables();
    this.updateOptions();
    this.updateMasterId(this.getVariantData());

    setTimeout(() => {
      this.updateMedia(true);
    }, 0);

    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(e) {
    this.updateVariables(e.target);

    if (!this.productTarget) {
      return;
    }

    this.groupFunctionsInit();

    if (!this.currentVariant) {
      this.groupFunctionsUnavailable();
    } else {
      this.groupFunctionsAvailable();
    }

    this.form?.dispatchEvent(new CustomEvent("variant:change", {
      detail: {
        variant: this.currentVariant
      }
    }));
  }

  updateVariables(target) {
    this.target = target;
    this.productTarget = this.closest(".product-container");
    this.variantQty = this.productTarget?.querySelector(".productVariantsQty");
    this.variantQtyData = this.variantQty ? JSON.parse(this.variantQty.textContent) : [];
    this.form = document.getElementById(this.getAttribute("form"));
    this.inputId = this.form?.querySelector('input[name="id"]');
    this.atcButton = this.form?.querySelector("[name='add']");
    this.atcButtonLabel = this.atcButton?.querySelector(".button-label");
    this.stickyAtcButton = document.querySelector(".sticky-atc-bar [name='add']");
    this.stickyAtcButtonLabel = this.stickyAtcButton?.querySelector(".button-label");
    this.prices = this.productTarget?.querySelectorAll(".product-price");
    this.inventoryStatus = this.productTarget?.querySelector(".product-inventory-wrapper");
    this.sku = this.productTarget?.querySelector(".product-sku-wrapper");
    this.mediaGallery = this.productTarget?.querySelector("media-gallery");
    this.variantPicker = this.productTarget?.querySelector(".product-detail__variant-picker");
    this.badges = this.productTarget?.querySelector(".product__badges");
  }

  groupFunctionsInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.updateProductInventory();
  }

  groupFunctionsUnavailable() {
    this.setUnavailable();
  }

  groupFunctionsAvailable() {
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInformation();
    this.setAvailable();
  }

  setUnavailable() {
    if (this.target) {
      const fieldset = this.target.closest("fieldset");
      const val = this.target.value;
      const optionSelected = fieldset.querySelector(".option_value");

      optionSelected.textContent = val;
    }

    if (this.atcButton) {
      this.atcButton.setAttribute("disabled", "disabled");
    }

    if (this.stickyAtcButton) {
      this.stickyAtcButton.setAttribute("disabled", "disabled");
    }

    if (this.atcButtonLabel) {
      this.atcButtonLabel.textContent = window.variantStrings.unavailable;
    }

    if (this.stickyAtcButtonLabel) {
      this.stickyAtcButtonLabel.textContent = window.variantStrings.unavailable;
    }

    this.prices.forEach((price) => {
      price.classList.add("hidden");
    });

    if (this.inventoryStatus) {
      this.inventoryStatus.classList.add("hidden");
    }

    if (this.sku) {
      this.sku.classList.add("hidden");
    }
  }

  setAvailable() {
    this.prices.forEach((price) => {
      price.classList.remove("hidden");
    });

    if (this.inventoryStatus) {
      this.inventoryStatus.classList.remove("hidden");
    }

    if (this.sku) {
      this.sku.classList.remove("hidden");
    }
  }

  updateMedia(firstLoad) {
    const layout = this.mediaGallery?.dataset.layout;

    if (!layout) {
      return;
    }

    if (layout === "carousel") {
      const slider = this.mediaGallery.querySelector("slide-with-thumbs");

      if (!slider) {
        return;
      }

      const slides = slider.querySelectorAll(".product-slider .media-gallery__image.swiper-slide");

      if (slides.length === 0 || !this.currentVariant?.featured_media) {
        return;
      }

      slides.forEach((slide, index) => {
        const mediaId = slide.getAttribute("data-media-id");

        if (mediaId && mediaId === `${this.dataset.section}-${this.currentVariant.featured_media.id}`) {
          const position = slide.getAttribute("data-position");

          slider.functionGoto(position - 1);
        }
      });
    } else if (!firstLoad) {
      const mediaElement = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media?.id || ''}"]`);

      if (mediaElement) {
        mediaElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  updateProductInventory() {
    const productInventory = this.productTarget?.querySelector("product-inventory");

    if (!productInventory) {
      return;
    }

    const productInventories = theme.helpers.safelyParseJson(this.productTarget?.querySelector("[data-product-inventories-json]")?.innerHTML || "[]");

    const lowThreshold = window.settings.productInventory.lowThreshold;
    const normalStockText = window.settings.productInventory.normalStockText;
    const lowStockText = window.settings.productInventory.lowStockText;
    const outOfStockText = window.settings.productInventory.outOfStockText;

    const text = productInventory.querySelector("span:first-of-type");

    const setInventoryState = (state, variantInventory) => {
      productInventory.classList.remove("product-inventory--in-stock", "product-inventory--low-stock", "product-inventory--out-of-stock");

      switch (state) {
        case "in-stock":
          productInventory.classList.add("product-inventory--in-stock");

          text.innerHTML = normalStockText;

          break;

        case "low-stock":
          let lowStock = lowStockText;

          productInventory.classList.add("product-inventory--low-stock");

          if (variantInventory) {
            lowStock = lowStock.replace("AMOUNT", variantInventory?.inventory_quantity);
          }

          text.innerHTML = lowStock;

          break;

        case "out-of-stock":
          productInventory.classList.add("product-inventory--out-of-stock");

          text.innerHTML = outOfStockText;

          break;
      }
    }

    if (!this.currentVariant) {
      setInventoryState("out-of-stock");

      return;
    }

    const variantInventory = productInventories.inventories[this.currentVariant.id];

    if (this.currentVariant.available) {
      if (variantInventory?.inventory_management === "shopify") {
        if (variantInventory?.inventory_policy === "continue") {
          setInventoryState("in-stock");
        } else {
          if (variantInventory?.inventory_quantity > 0) {
            if (variantInventory.inventory_quantity < lowThreshold) {
              setInventoryState("low-stock", variantInventory);
            } else {
              setInventoryState("in-stock");
            }
          } else {
            setInventoryState("out-of-stock");
          }
        }
      } else {
        setInventoryState("in-stock");
      }
    } else {
      setInventoryState("out-of-stock");
    }
  }

  renderProductInformation() {
    if (this.sku) {
      this.sku.innerHTML = this.currentVariant.sku ? this.currentVariant.sku : "N/A";
    }

    if (this.variantPicker) {
      const type = this.variantPicker.dataset.type || "swatches";

      const updateOptionValues = (selector) => {
        const optionElements = this.productTarget.querySelectorAll(selector);

        optionElements.forEach((element, index) => {
          const optionValue = this.currentVariant[`option${index + 1}`];

          if (optionValue) {
            element.innerHTML = optionValue;
          }
        });
      };

      if (type === "swatches") {
        updateOptionValues(".option_value");
      } else {
        updateOptionValues(".option_drop_value .option_value");
        updateOptionValues(".swatch-dropdown-select-value .option_value");

        const closestSwatchDropdown = this.target.closest("swatch-dropdown");

        if (closestSwatchDropdown && closestSwatchDropdown.classList.contains("active")) {
          closestSwatchDropdown.classList.remove("active");
        }
      }
    }

    this.renderBtnStatus();
    this.updateBadges();
  }

  updateBadges() {
    if (!this.badges) {
      return;
    }

    const compareAtPrice = this.currentVariant.compare_at_price;
    const price = this.currentVariant.price;
    let variantQuantity = 0;

    this.variantQtyData.find((variantQty) => {
      if (variantQty.id === this.currentVariant.id) {
        variantQuantity = variantQty.qty;
      }
    });


    const saleBadge = this.badges.querySelector(".product__badge--sale");

    if (saleBadge) {
      const saleValueBlock = saleBadge.querySelector(".sale-value");
      const type = saleBadge.dataset.type;

      if (compareAtPrice && compareAtPrice > price) {
        if (type !== "text") {
          let value = Shopify.formatMoney(compareAtPrice - price, window.settings.moneyFormat);

          if (type === "percent") {
            value = `${Math.floor(((compareAtPrice - price) / compareAtPrice) * 100)}%`;
          }

          saleValueBlock.innerHTML = value;
        }

        saleBadge.classList.remove("!hidden");
      } else {
        saleBadge.classList.add("!hidden");
      }
    }


    const soldOutBadge = this.badges.querySelector(".product__badge--sold-out");

    if (soldOutBadge) {
      let isSoldOut = false;

      if (this.currentVariant.inventory_management !== null && !this.currentVariant.available) {
        isSoldOut = true;
      }

      if (isSoldOut) {
        soldOutBadge.classList.remove("!hidden");
      } else {
        soldOutBadge.classList.add("!hidden");
      }
    }


    const preOrderBadge = this.badges.querySelector(".product__badge--pre-order");

    if (preOrderBadge) {
      let isPreOrder = false;

      if (this.currentVariant.available && variantQuantity < 1) {
        isPreOrder = true;
      }

      if (isPreOrder) {
        preOrderBadge.classList.remove("!hidden");
      } else {
        preOrderBadge.classList.add("!hidden");
      }
    }
  }

  renderBtnStatus() {
    if (!this.atcButton || !this.atcButtonLabel) {
      return;
    }

    let variantQuantity = 0;

    this.variantQtyData.find((variantQty) => {
      if (variantQty.id === this.currentVariant.id) {
        variantQuantity = variantQty.qty;
      }
    });

    if (this.currentVariant.inventory_management === null) {
      this.atcButtonLabel.innerHTML = window.variantStrings.addToCart;

      this.atcButton.disabled = false;
    } else {
      if (this.currentVariant.available) {
        if (variantQuantity < 1) {
          this.atcButtonLabel.innerHTML = window.variantStrings.preOrder;

          this.atcButton.disabled = false;
        } else {
          this.atcButtonLabel.innerHTML = window.variantStrings.addToCart;

          this.atcButton.disabled = false;
        }
      } else {
        this.atcButtonLabel.innerHTML = window.variantStrings.soldOut;

        this.atcButton.disabled = true;
      }
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => {
      return this.querySelector(":checked").value === variant.option1;
    });

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) {
        return;
      }

      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => {
        return variant.available && variant[`option${index}`] === previousOptionSelected;
      }).map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("option-disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement ? value : window.variantStrings.unavailableWithOption.replace("[value]", value);
      }
    });
  }

  updateOptions() {
    this.options = [];

    Array.from(this.querySelectorAll("select, fieldset"), (element) => {
      if (element.tagName === "SELECT") {
        this.options.push(element.value);
      } else if (element.tagName === "FIELDSET") {
        const optionName = Array.from(element.querySelectorAll("input")).find((radio) => {
          return radio.checked;
        })?.value;

        if (optionName) {
          this.options.push(optionName);
        }
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }

    window.history.replaceState({}, "", `${location.origin}${location.pathname}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    if (!this.inputId) {
      return;
    }

    this.inputId.value = this.currentVariant.id;
    this.inputId.dispatchEvent(new Event("change", { bubbles: true }));
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");

    if (!pickUpAvailability) {
      return;
    }

    if (this.currentVariant && this.currentVariant.available) {
      if (pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  getVariantData() {
    const jsonContent = this.querySelector('[type="application/json"]');

    this.variantData = this.variantData || (jsonContent ? JSON.parse(jsonContent.textContent) : []);

    return this.variantData;
  }
}


class ProductForm extends ModalBase {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.cart = document.querySelector("cart-page, cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    this.hideErrors = this.dataset.hideErrors === "true";
    this.productItem = this.form.closest(".product-item");

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    if (this.submitButton.getAttribute("aria-disabled") === "true") {
      return;
    }

    this.activeElement = evt.submitter || evt.currentTarget;

    this.handleErrorMessage();
    this.submitButton.setAttribute("aria-disabled", "true");
    this.submitButton.classList.add("loading");

    const config = theme.helpers.fetchConfig("javascript");

    config.headers["X-Requested-With"] = "XMLHttpRequest";

    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    const productInfo = this.form.closest(".product__information");

    productInfo?.querySelectorAll(".product-property input").forEach((property) => {
      if (property.classList.contains("text") && property.value) {
        formData.append(property.name, property.value);
      }
    });

    if (this.cart) {
      formData.append("sections", this.cart.getSectionsToRender().map((section) => section.name));
      formData.append("sections_url", window.location.pathname);
    }

    const isCartPage = document.body.classList.contains("template-cart");

    if (isCartPage) {
      formData.append("sections", this.getMainCartSectionRender().map((section) => section.name));
    }

    config.body = formData;

    if (this.cart) {
      this.cart.classList.add("loading");
    }

    fetch(`${window.routes.cartAddUrl}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.dispatchEvent(new CustomEvent("theme:product:error", {
            detail: {
              productVariantId: +formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            }
          }));

          this.handleErrorMessage(response.description);

          if (this.productItem) {
            this.handleErrorMessagePopup(response.description);
          }

          return;
        } else if (response.sections) {
          if (!response.id && !response.items) {
            this.handleErrorMessagePopup(window.cartStrings.error);

            return;
          }
        } else if (!this.cart) {
          window.location = window.routes.cartUrl;

          return;
        }

        fetch(`${window.routes.cartUrl}.json`)
          .then((res) => res.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent("theme:cart:count:update", {
              detail: {
                count: cart.item_count
              }
            }));

            const freeShippingBar = document.querySelector("free-shipping-bar");

            if (freeShippingBar) {
              freeShippingBar.init(cart.items_subtotal_price);
            }
          })
          .catch((error) => {
            throw error;
          });

        document.dispatchEvent(new CustomEvent("theme:product:added", {
          detail: {
            productVariantId: +formData.get("id")
          }
        }));

        const quickViewModals = document.querySelectorAll(".modal--visible.modal.quickview");

        quickViewModals.forEach((modal) => {
          const closeButton = modal.querySelector(".modal__close");

          if (closeButton) {
            closeButton.dispatchEvent(new Event("click"));
          }
        });

        const isCartPage = document.body.classList.contains("template-cart");

        if (!isCartPage) {
          if (!response.errors) {
            this.cart.getSectionsToRender().forEach((section) => {
              const html = new DOMParser().parseFromString(response.sections[section.name], "text/html");
              const currentSection = document.getElementById(section.id).querySelector("#cart-drawer-form");

              const currentProducts = currentSection.querySelector(".cart-drawer__products");
              const currentFooter = currentSection.querySelector(".cart-drawer__footer");

              const parsedProducts = html.querySelector(".cart-drawer__products");
              const parsedFooter = html.querySelector(".cart-drawer__footer");

              if (currentFooter && parsedFooter) {
                let productsRange = document.createRange();
                let footerRange = document.createRange();

                productsRange = productsRange.createContextualFragment(parsedProducts.innerHTML);
                footerRange = footerRange.createContextualFragment(parsedFooter.innerHTML);

                currentProducts.replaceChildren(productsRange);
                currentFooter.replaceChildren(footerRange);
              } else {
                currentSection.innerHTML = html.querySelector("#cart-drawer-form").innerHTML;
              }
            });

            this.cart.initCartActions();

            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }

            this.cart.open(this.activeElement);

            document.dispatchEvent(new CustomEvent("hover-button:apply"));
          }
        } else {
          if (!response.errors) {
            this.getMainCartSectionRender().forEach((section) => {
              const html = new DOMParser().parseFromString(response.sections[section.name], "text/html");
              const currentSection = document.getElementById(section.id);

              const currentProducts = currentSection.querySelector(".main-cart__content");
              const currentTotals = currentSection.querySelector(".cart-info .totals");
              const currentDiscounts = currentSection.querySelector(".cart-page__discounts");

              const parsedTotals = html.querySelector(".cart-info .totals");
              const parsedProducts = html.querySelector(".main-cart__content");
              const parsedDiscounts = html.querySelector(".cart-page__discounts");

              currentProducts.innerHTML = parsedProducts.innerHTML;
              currentTotals.innerHTML = parsedTotals.innerHTML;

              if (currentDiscounts && parsedDiscounts) {
                currentDiscounts.innerHTML = parsedDiscounts.innerHTML;
              }

              const focusableElement = currentProducts?.querySelector("a");

              focusableElement?.focus();
            });

            this.cart.initCartActions();

            document.dispatchEvent(new CustomEvent("hover-button:apply"));
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.cart?.classList.remove("loading");
        this.submitButton.classList.remove("loading");

        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }

        this.submitButton.removeAttribute("aria-disabled");
      });
  }

  getMainCartSectionRender() {
    return [
      {
        name: "main-cart-items",
        id: "CartPage",
      },
    ];
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) {
      return;
    }

    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");

    if (!this.errorMessageWrapper) {
      return;
    }

    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector("span");

    this.errorMessageWrapper.classList.toggle("!hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  handleErrorMessagePopup(errorMessage = false) {
    const url = `${window.location.pathname}?section_id=form-message`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const elementErrorMessage = html.querySelector(".product-form__error-message-wrapper");
        const elementMessage = elementErrorMessage.querySelector(".product-form__error-message");

        elementMessage.textContent = errorMessage;

        showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
      })
      .catch((e) => {
        throw e;
      });
  }
}

if (!window.customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}


class CheckoutDynamicButtons extends HTMLElement {
  constructor() {
    super();

    this.addFlairToButton();
  }

  connectedCallback() {
    this.addFlairToButton();
  }

  addFlairToButton() {
    const buyNow = this.querySelector(".shopify-payment-button__button--unbranded");

    if (buyNow) {
      const hasFlair = buyNow.querySelector(".button__flair");

      if (hasFlair) {
        return;
      }

      buyNow.innerHTML = `<span class="button__inner">${buyNow.innerHTML}</span>`;
      buyNow.insertAdjacentHTML("afterbegin", `<span class="button__flair"></span>`);

      document.dispatchEvent(new CustomEvent("hover-button:apply"));
    } else {
      const mutationObserver = new MutationObserver((mutations) => {
        const buyNow = this.querySelector(".shopify-payment-button__button--unbranded");

        if (!buyNow) {
          return;
        }

        const hasFlair = buyNow.querySelector(".button__flair");

        if (hasFlair) {
          return;
        }

        buyNow.innerHTML = `<span class="button__inner">${buyNow.innerHTML}</span>`;
        buyNow.insertAdjacentHTML("afterbegin", `<span class="button__flair"></span>`);

        document.dispatchEvent(new CustomEvent("hover-button:apply"));

        mutationObserver.disconnect();
      });

      mutationObserver.observe(this, {
        childList: true,
        subtree: true
      });
    }
  }
}

if (!window.customElements.get("checkout-dynamic-buttons")) {
  customElements.define("checkout-dynamic-buttons", CheckoutDynamicButtons);
}


class PaymentTerms extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    if (variant) {
      const element = this.querySelector('[name="id"]');

      element.value = event.detail.variant["id"];
      element.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}

if (!window.customElements.get("payment-terms")) {
  customElements.define("payment-terms", PaymentTerms);
}


class VariantRadios extends SwatchFunctions {
  constructor() {
    super();
  }

  init() {
    this.querySelectorAll(".product__color-swatch-option").forEach((btn) => {
      this.checkSwatches(btn);

      btn.addEventListener("click", this.onVariantChange.bind(this), false);
    });
  }

  onVariantChange(e) {
    e.preventDefault();

    const target = e.currentTarget;

    this.productTarget = this.closest(".product-container");
    this.swatchPosition = target.dataset.position;

    const variantQtyData = JSON.parse(this.productTarget.querySelector(".productItemVariantsQty").textContent);

    if (!target.classList.contains("active")) {
      const activeSwatches = target.closest(".product__color-swatches").querySelectorAll(".product__color-swatch-option");

      activeSwatches.forEach((el) => {
        el.classList.remove("active");
      });

      target.classList.toggle("active");

      this.groupFunctionsInit(this.getVariantData());

      if (this.currentVariant) {
        this.groupFunctionsAvailable(variantQtyData);
      }
    }
  }

  groupFunctionsInit(variantData) {
    this.updateOptions();
    this.updateMasterId(variantData);
  }

  groupFunctionsAvailable(variantQtyData) {
    this.updateMedia();
  }

  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    }));
  }

  updateOptions() {
    this.options = Array.from(this.productTarget.querySelectorAll(".product__color-swatch-option.active"), (select) => {
      select.getAttribute("data-value");
    });

    if (!this.variantData) {
      return;
    }

    this.variantData.find((variant) => {
      if (this.options.length === 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };

        if (variantOptions[this.swatchPosition] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) {
      return;
    }

    if (!this.productTarget.querySelector(".product__media img").classList.contains("hidden")) {
      const productItem = this.productTarget.querySelector(".product__media img").closest('.product-item');

      if (productItem.querySelector('video') || productItem.querySelector('iframe')) {
        this.productTarget.querySelector(".product__media img").classList.add("hidden");

        productItem.querySelector('video')?.classList.remove("hidden");
        productItem.querySelector('iframe')?.classList.remove("hidden");
      }
    }

    if (!this.currentVariant.featured_media) {
      return;
    }

    if (this.productTarget.querySelector(".product__media img")) {
      this.productTarget.querySelector(".product__media img").removeAttribute("srcset");
    }

    if (this.productTarget.querySelector(".product__media img")) {
      this.productTarget.querySelector(".product__media img").setAttribute("src", this.currentVariant.featured_media.preview_image.src);
    }

    if (this.productTarget.querySelector(".product__media img").classList.contains("hidden")) {
      this.productTarget.querySelector(".product__media img").classList.remove("hidden");

      const productItem = this.productTarget.querySelector(".product__media img").closest('.product-item');

      if (productItem.querySelector("video") || productItem.querySelector("iframe")) {
        productItem.querySelector("video")?.classList.add("hidden");
        productItem.querySelector("iframe")?.classList.add("hidden");
      }
    }
  }
}

if (!window.customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}


class VariantRadiosDetail extends SwatchFunctions {
  constructor() {
    super();
  }

  groupFunctionsAvailable(variantQtyData, target) {
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInformation(this.productTarget, variantQtyData, target);
    this.updateMedia();
    this.setAvailable();
  }
}

if (!window.customElements.get("variant-radios-detail")) {
  customElements.define("variant-radios-detail", VariantRadiosDetail);
}


class SalePrice extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];
    this.priceValue = this.querySelector("[data-price-value]");

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  handleVariantChange(e) {
    const variant = e.detail.variant;

    if (!variant) {
      return;
    }

    const formattedPrice = Shopify.formatMoney(variant.price, window.settings.moneyFormat);

    if (variant.compare_at_price) {
      this.classList.add("color-sale-price", "medium-weight");
    } else {
      this.classList.remove("color-sale-price", "medium-weight");
    }

    if (!this.priceValue) {
      return;
    }

    this.priceValue.innerText = formattedPrice;
  }
}

if (!window.customElements.get("sale-price")) {
  customElements.define("sale-price", SalePrice);
}


class CompareAtPrice extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];
    this.priceValue = this.querySelector("[data-price-value]");

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  handleVariantChange(e) {
    const variant = e.detail.variant;

    if (!variant) {
      return;
    }

    const formattedPrice = Shopify.formatMoney(variant.compare_at_price, window.settings.moneyFormat);

    if (!this.priceValue) {
      return;
    }

    this.priceValue.innerText = formattedPrice;

    if (variant.compare_at_price > variant.price) {
      this.removeAttribute("hidden");
    } else {
      this.setAttribute("hidden", "hidden");
    }
  }
}

if (!window.customElements.get("compare-at-price")) {
  customElements.define("compare-at-price", CompareAtPrice);
}


class TitleVariant extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];
    this.valueEl = this.querySelector("[data-title-variant-value]");
    this.suffixLevels = this.getAttribute("data-suffix-levels") || "all";

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  handleVariantChange(e) {
    const variant = e.detail.variant;

    if (!variant || !this.valueEl) {
      return;
    }

    const text = this.suffixLevels === "first" ? variant.option1 : variant.title.split(" / ").join(" - ");

    this.valueEl.textContent = "(" + text + ")";
  }
}

if (!window.customElements.get("title-variant")) {
  customElements.define("title-variant", TitleVariant);
}


class VariantPriceSync extends HTMLElement {
  constructor() {
    super();

    this.position = this.getAttribute("data-position");

    const dataScript = this.querySelector('script[type="application/json"]');
    this.variants = dataScript ? JSON.parse(dataScript.textContent) : [];

    this.handleChangeListener = this.update.bind(this);

    this.isDragging = false;
    this.dragMoved = false;
    this.dragStartX = 0;
    this.dragScrollStart = 0;

    this.handleMouseDownListener = this.handleMouseDown.bind(this);
    this.handleMouseMoveListener = this.handleMouseMove.bind(this);
    this.handleMouseUpListener = this.handleMouseUp.bind(this);
    this.handleWheelListener = this.handleWheel.bind(this);
  }

  connectedCallback() {
    /* Radios live outside the real <form> (associated only via the
       form="..." attribute), so a native "change" listener on the form
       never sees them bubble in — listen on the actual DOM ancestor
       that wraps every option fieldset instead. */
    this.scope = this.closest("variant-radios-detail") || this;
    this.scope.addEventListener("change", this.handleChangeListener);
    this.update();

    /* Touch already scrolls natively via overflow-x. Mouse drag and
       plain mouse-wheel (as opposed to a trackpad's native horizontal
       swipe, which the browser already handles) need explicit JS. */
    this.addEventListener("mousedown", this.handleMouseDownListener);
    this.addEventListener("wheel", this.handleWheelListener, { passive: false });
  }

  disconnectedCallback() {
    this.scope?.removeEventListener("change", this.handleChangeListener);
    this.removeEventListener("mousedown", this.handleMouseDownListener);
    this.removeEventListener("wheel", this.handleWheelListener);
    document.removeEventListener("mousemove", this.handleMouseMoveListener);
    document.removeEventListener("mouseup", this.handleMouseUpListener);
  }

  handleMouseDown(e) {
    this.isDragging = true;
    this.dragMoved = false;
    this.dragStartX = e.pageX;
    this.dragScrollStart = this.scrollLeft;

    document.addEventListener("mousemove", this.handleMouseMoveListener);
    document.addEventListener("mouseup", this.handleMouseUpListener);
  }

  handleMouseMove(e) {
    if (!this.isDragging) {
      return;
    }

    const distance = e.pageX - this.dragStartX;

    if (Math.abs(distance) > 3) {
      this.dragMoved = true;
      this.classList.add("is-dragging");
    }

    if (!this.dragMoved) {
      return;
    }

    e.preventDefault();
    this.scrollLeft = this.dragScrollStart - distance;
  }

  handleMouseUp() {
    this.isDragging = false;
    this.classList.remove("is-dragging");

    document.removeEventListener("mousemove", this.handleMouseMoveListener);
    document.removeEventListener("mouseup", this.handleMouseUpListener);
  }

  handleWheel(e) {
    if (this.scrollWidth <= this.clientWidth) {
      return;
    }

    const delta = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

    if (delta === 0) {
      return;
    }

    e.preventDefault();
    this.scrollLeft += delta;
  }

  update() {
    if (!this.scope) {
      return;
    }

    const otherValues = {};

    this.scope.querySelectorAll("input[type='radio']:checked[data-position]").forEach((input) => {
      if (input.dataset.position !== this.position) {
        otherValues[input.dataset.position] = input.value;
      }
    });

    this.querySelectorAll("[data-variant-price-value]").forEach((el) => {
      const value = el.dataset.variantPriceValue;

      const exactMatch = this.variants.find((variant) => {
        if (variant["option" + this.position] !== value) {
          return false;
        }

        return Object.keys(otherValues).every((position) => variant["option" + position] === otherValues[position]);
      });

      const variant = exactMatch || this.variants.find((v) => v["option" + this.position] === value);

      if (!variant) {
        return;
      }

      const saleEl = el.querySelector("[data-price-sale]");
      const compareEl = el.querySelector("[data-price-compare]");
      const onSale = variant.compare_at_price > variant.price;

      if (saleEl) {
        saleEl.textContent = Shopify.formatMoney(variant.price, window.settings.moneyFormat);
        saleEl.classList.toggle("color-sale-price", onSale);
        saleEl.classList.toggle("color-text", !onSale);
      }

      if (compareEl) {
        if (onSale) {
          compareEl.textContent = Shopify.formatMoney(variant.compare_at_price, window.settings.moneyFormat);
          compareEl.removeAttribute("hidden");
        } else {
          compareEl.setAttribute("hidden", "hidden");
        }
      }
    });
  }
}

if (!window.customElements.get("variant-price-sync")) {
  customElements.define("variant-price-sync", VariantPriceSync);
}


class UnitPrice extends HTMLElement {
  constructor() {
    super();

    this.formId = this.getAttribute("form");
    this.form = document.forms[this.formId];
    this.unitPrice = this.querySelector("[data-unit-price]");
    this.unit = this.querySelector("[data-unit]");

    this.handleVariantChangeListener = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.form?.addEventListener("variant:change", this.handleVariantChangeListener);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("variant:change", this.handleVariantChangeListener);
  }

  handleVariantChange(e) {
    const variant = e.detail.variant;

    if (!variant || !variant.unit_price) {
      this.setAttribute("hidden", "hidden");

      return;
    }

    const variantReferenceValue = variant.unit_price_measurement.reference_value;
    const referenceValue = variantReferenceValue !== 1 ? variantReferenceValue : "";
    const referenceUnit = variant.unit_price_measurement.reference_unit;
    const unitPrice = variant.unit_price;

    this.unitPrice.innerText = Shopify.formatMoney(unitPrice, window.settings.moneyFormat);
    this.unit.innerText = `${referenceValue} ${referenceUnit}`;

    this.removeAttribute("hidden");
  }
}

if (!window.customElements.get("unit-price")) {
  customElements.define("unit-price", UnitPrice);
}


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.main = document.getElementById("MainContent");
    this.form = this.querySelector("form");
    this.input = this.querySelector("input[type='search']");
    this.inputPlaceholder2 = this.input.getAttribute("data-placeholder-2");
    this.inputPlaceholder3 = this.input.getAttribute("data-placeholder-3");
    this.enableTypewriterEffect = this.hasAttribute("data-enable-typewriter-effect");
    this.collectionsColorScheme = this.getAttribute("data-collections-color-scheme") || "default";

    this.clearAllButton = this.querySelector(".predictive-search__clear-button");
    this.popularTermsWrapper = this.querySelector("#search-suggestions");
    this.linksWrapper = this.querySelector("#search-links");
    this.productsWrapper = this.querySelector("#search-products");
    this.popularTerms = this.popularTermsWrapper?.querySelectorAll("a");
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.predictiveSearchDropdown = this.querySelector(".search-page__dropdown");
    this.predictiveSearchOverlay = this.querySelector("overlay-component");

    if (this.enableTypewriterEffect) {
      this.addTypewriterEffectToInput();
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.popularTerms?.forEach((suggestion) => {
      suggestion.addEventListener("click", () => {
        this.input.value = suggestion.dataset.term;

        this.input.dispatchEvent(new Event("input"));
      });
    });

    this.input.addEventListener("input", theme.helpers.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));

    document.addEventListener("focusin", () => {
      if (!document.activeElement.closest(".search-page__dropdown") && !document.activeElement.closest("predictive-search") && !document.activeElement.closest(".modal.quickview")) {
        this.predictiveSearchDropdown?.classList.add("invisible");
        this.classList.remove("predictive-search--show-overlay");
        this.main.style.zIndex = "1";
      }
    });

    this.predictiveSearchOverlay?.addEventListener("click", () => {
      this.predictiveSearchDropdown?.classList.add("invisible");
      this.classList.remove("predictive-search--show-overlay");
      this.main.style.zIndex = "1";
    });

    this.clearAllButton.addEventListener("click", () => {
      this.input.value = "";
      this.predictiveSearchResults.classList.remove("results");
      this.popularTermsWrapper?.classList.remove("!hidden");
      this.linksWrapper?.classList.remove("!hidden");
      this.productsWrapper?.classList.remove("!hidden");
      this.clearAllButton.classList.add("!hidden");
      this.clearAllButton.setAttribute("disabled", "disabled");
      this.predictiveSearchDropdown?.classList.add("invisible");
      this.classList.remove("predictive-search--show-overlay");
      this.main.style.zIndex = "1";

      this.dispatchEvent(new CustomEvent("theme:predictive-search:no-results"));
    });

    document.addEventListener("focusout", this.onFocusOut.bind(this));
  }

  onFocus() {
    const searchTerm = this.getQuery();

    this.classList.add("predictive-search--show-overlay");
    this.main.style.zIndex = "10";

    if (!searchTerm.length) {
      return;
    }

    if (this.predictiveSearchResults.classList.contains("results")) {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }

    this.clearAllButton.classList.remove("!hidden");
    this.clearAllButton.removeAttribute("disabled");
    this.predictiveSearchDropdown?.classList.remove("invisible");
  }

  onFocusOut() {
    setTimeout(() => {
      if (!document.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.clearAllButton.classList.add("!hidden");
      this.clearAllButton.setAttribute("disabled", "disabled");
      this.close();

      return;
    }

    this.clearAllButton.classList.remove("!hidden");
    this.clearAllButton.removeAttribute("disabled");

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const cachedResults = {};
    const queryKey = searchTerm.replace(" ", "+").toLowerCase();

    this.setLiveRegionLoadingState();

    if (cachedResults[queryKey]) {
      this.renderSearchResults(cachedResults[queryKey]);

      return;
    }

    fetch(`${window.routes.predictiveSearchUrl}?q=${queryKey}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=search-predictive-grid`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }

        return response.text();
      })
      .then((text) => {
        const results = new DOMParser().parseFromString(text, "text/html").querySelector(`#shopify-section-search-predictive-grid`);
        const resultsMarkup = results.innerHTML;
        const noResults = results.querySelector(".no-results");

        cachedResults[queryKey] = resultsMarkup;

        this.renderSearchResults(resultsMarkup);

        if (noResults) {
          this.dispatchEvent(new CustomEvent("theme:predictive-search:no-results"));
        } else {
          this.dispatchEvent(new CustomEvent("theme:predictive-search:has-results"));
        }

        document.dispatchEvent(new CustomEvent("hover-button:apply"));
      })
      .catch((error) => {
        this.close();

        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.predictiveSearchResults.classList.add("results");

    const collectionItems = this.predictiveSearchResults.querySelectorAll(".collection-item");

    collectionItems.forEach((item) => {
      item.classList.add(`color-${this.collectionsColorScheme}`);
    });

    this.popularTermsWrapper?.classList.add("!hidden");
    this.linksWrapper?.classList.add("!hidden");
    this.productsWrapper?.classList.add("!hidden");

    this.setLiveRegionResults();
    this.open();

    this.popularTerms?.forEach((suggestion) => {
      const flair = suggestion.querySelector(".button__flair");

      flair.style.transform = "translate(50%, 50%) scale(0)"
    });

    this.predictiveSearchDropdown?.classList.remove("invisible");
    this.classList.add("predictive-search--show-overlay");
  }

  setLiveRegionLoadingState() {
    this.form.classList.add("loading");
    this.predictiveSearchResults.classList.add("loading");
  }

  setLiveRegionResults() {
    this.form.classList.remove("loading");
    this.predictiveSearchResults.classList.remove("loading");
  }

  getQuery() {
    return this.input.value.trim();
  }

  open() {
    this.input.setAttribute("aria-expanded", "true");
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.predictiveSearchResults.classList.remove("results");
      this.popularTermsWrapper?.classList.remove("!hidden");
      this.linksWrapper?.classList.remove("!hidden");
      this.productsWrapper?.classList.remove("!hidden");
    }

    const selected = this.querySelector("[aria-selected='true']");

    if (selected) {
      selected.setAttribute("aria-selected", "false");
    }

    this.input.setAttribute("aria-activedescendant", "");
    this.input.setAttribute("aria-expanded", "false");

    this.predictiveSearchDropdown?.classList.add("invisible");

    this.dispatchEvent(new CustomEvent("theme:predictive-search:no-results"));
  }

  addTypewriterEffectToInput() {
    if (!this.inputPlaceholder2 || !this.inputPlaceholder3) {
      return;
    }

    const typingSpeed = this.input.dataset.typingSpeed || 100;
    const deletingSpeed = this.input.dataset.deletingSpeed || 60;
    const delayAfterDeleting = this.input.dataset.delayAfterDeleting || 500;
    const delayBeforeFirstDelete = this.input.dataset.delayBeforeFirstDelete || 2000;
    const delayAfterWordTyped = this.input.dataset.delayAfterWordTyped || 2400;
    const placeholders = [];

    if (this.input.getAttribute("placeholder")) {
      placeholders.push(this.input.getAttribute("placeholder"));
    }

    if (this.inputPlaceholder2) {
      placeholders.push(this.inputPlaceholder2);
    }

    if (this.inputPlaceholder3) {
      placeholders.push(this.inputPlaceholder3);
    }

    const typeInNextPlaceholder = async (placeholder) => {
      await new Promise((resolve) => {
        let currentPlaceholder = this.input.getAttribute("placeholder");
        let nextPlaceholder = placeholder;

        if (currentPlaceholder.length >= 3 && placeholder.startsWith(currentPlaceholder)) {
          nextPlaceholder = placeholder.replace(currentPlaceholder, "");
        }

        const typingIntervalId = setInterval(() => {
          currentPlaceholder = this.input.getAttribute("placeholder");

          this.input.setAttribute("placeholder", currentPlaceholder + nextPlaceholder.charAt(0));

          if (nextPlaceholder.length === 1) {
            resolve();

            clearInterval(typingIntervalId);
          } else {
            nextPlaceholder = nextPlaceholder.substring(1);
          }
        }, typingSpeed);
      });
    };

    const deleteCurrentPlaceholder = async (nextPlaceholder) => {
      await new Promise(resolve=>{
        let prevPlaceholder = this.input.getAttribute("placeholder");

        const deletionIntervalId = setInterval(() => {
          const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);

          this.input.setAttribute("placeholder", newPlaceholder);

          prevPlaceholder = newPlaceholder;

          if (prevPlaceholder.length === 0 || prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder)) {
            resolve();
            clearInterval(deletionIntervalId);
          }
        }, deletingSpeed)
      });
    };

    let startIndex = 0;

    const showNextPlaceholder = () => {
      startIndex = (startIndex + 1) % placeholders.length;

      const nextPlaceholder = placeholders[startIndex];

      deleteCurrentPlaceholder.call(this, nextPlaceholder).then(() => {
        setTimeout(() => {
          typeInNextPlaceholder.call(this, nextPlaceholder).then(() => {
            setTimeout(showNextPlaceholder.bind(this), delayAfterWordTyped);
          });
        }, delayAfterDeleting);
      });
    };

    setTimeout(showNextPlaceholder.bind(this), delayBeforeFirstDelete);
  }
}

if (!window.customElements.get("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}


class DisclosureItem extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.getAttribute("trigger") || "click";
    this.button = this.querySelector(".disclosure__button");
    this.listWrapper = this.querySelector(".disclosure__list-wrapper");
    this.list = this.querySelector(".disclosure__list");
    this.intervalId = null;
    this.isClicked = false;

    this.setAttribute("aria-expanded", "false");

    document.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    if (this.trigger === "hover") {
      this.button.addEventListener("mouseenter", this.openSelector.bind(this));
      this.button.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
      this.listWrapper.addEventListener("mouseenter", this.handleContentMouseEnter.bind(this));
      this.listWrapper.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
    }

    this.button.addEventListener("click", this.openSelector.bind(this));
    this.button.addEventListener("focus", this.openSelector.bind(this));

    this.button.addEventListener("pointerdown", () => {
      this.isClicked = true;
    });

    document.addEventListener("focusin", this.handleFocusIn.bind(this));

    this.handleBodyClickListener = this.handleBodyClick.bind(this);
    this.handleTransitionEndListener = this.handleTransitionEnd.bind(this);

    this.updateHeightVariable();
  }

  handleTransitionEnd(evt) {
    if (evt.target !== this.listWrapper) {
      return;
    }

    if (this.button.classList.contains("open")) {
      this.classList.add("opened");
      this.setAttribute("aria-expanded", "true");
    } else {
      this.closeAllCollapsibleBlocks();
      this.setAttribute("aria-expanded", "false");
    }

    this.removeEventListener("transitionend", this.handleTransitionEndListener, false);
  }

  handleContentMouseEnter() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);

      this.intervalId = null;
    }
  }

  handleMouseLeave() {
    this.intervalId = setTimeout(this.hidePanel.bind(this), 200);
  }

  handleFocusIn() {
    if (!document.activeElement.closest("disclosure-item")) {
      this.hidePanel();
    }
  }

  closeAllCollapsibleBlocks() {
    const blocks = this.querySelectorAll(".collapsible-block");

    blocks.forEach((block) => {
      const content = block.querySelector(".collapsible-content");

      block.classList.remove("active");
      content.style.display = "none";
    });
  }

  openSelector(evt, showForce) {
    if (this.isClicked && evt.type !== "click") {
      return;
    }

    evt.preventDefault();

    this.isClicked = false;

    this.classList.remove("opened");
    this.removeEventListener("transitionend", this.handleTransitionEndListener, false);

    if (this.intervalId) {
      clearTimeout(this.intervalId);

      this.intervalId = null;
    }

    if (showForce) {
      const allButtons = document.querySelectorAll(".disclosure");

      allButtons.forEach((button) => {
        button.hidePanel();
      });

      this.button.classList.add("open");

      document.body.addEventListener("click", this.handleBodyClickListener);
    } else if (evt.type === "click" && this.trigger === "hover") {
      const url = this.dataset.url;

      if (url && !window.matchMedia("(hover: none)").matches) {
        window.location.href = url;
      } else {
        if (this.button.classList.contains("open")) {
          this.button.classList.remove("open");
        } else {
          this.button.classList.add("open");
        }
      }
    } else if (this.trigger === "click" && this.button.classList.contains("open")) {
      this.button.classList.remove("open");
    } else {
      const allButtons = document.querySelectorAll(".disclosure");

      allButtons.forEach((button) => {
        button.hidePanel();
      });

      this.button.classList.add("open");

      document.body.addEventListener("click", this.handleBodyClickListener);
    }

    this.addEventListener("transitionend", this.handleTransitionEndListener, false);
  }

  hidePanel() {
    if (this.classList.contains("disclosure--not-close")) {
      return;
    }

    document.body.removeEventListener("click", this.handleBodyClickListener);
    this.removeEventListener("transitionend", this.handleTransitionEndListener, false);

    this.classList.remove("opened");
    this.button.classList.remove("open");

    this.addEventListener("transitionend", this.handleTransitionEndListener, false);
  }

  onContainerKeyUp(event) {
    if (event.code && event.code.toUpperCase() !== "ESCAPE") {
      return;
    }

    this.hidePanel();
    this.button.focus();
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this && !target.closest(".disclosure")) {
      this.hidePanel();
    }
  }

  updateHeightVariable() {
    if (!this.list) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === this.list) {
          this.style.setProperty("--list-height", `${entry.target.getBoundingClientRect().height}px`);
        }
      }
    });

    resizeObserver.observe(this.list);
  }
}

if (!window.customElements.get("disclosure-item")) {
  customElements.define("disclosure-item", DisclosureItem);
}


class SwatchDropdownSelect extends DisclosureItem {
  constructor() {
    super();

    this.listItems = this.querySelectorAll(".disclosure__item");

    this.listItems.forEach((item) => {
      item.addEventListener("click", () => {
        this.hidePanel();
      });
    });
  }
}

if (!window.customElements.get("swatch-dropdown-select")) {
  customElements.define("swatch-dropdown-select", SwatchDropdownSelect);
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.input.addEventListener("keypress", this.onKeyPress.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onKeyPress(evt) {
    const isNumberKey = evt.which >= 48 && evt.which <= 57;
    const isBackspaceOrDelete = evt.which === 8 || evt.which === 0;

    if (!isNumberKey && !isBackspaceOrDelete) {
      evt.preventDefault();
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;

    event.target.name === "plus" || event.target.closest("button").name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity-input__button[name='minus']");

      buttonMinus.classList.toggle("disabled", value <= min);
    }

    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity-input__button[name='plus']");

      buttonPlus.classList.toggle("disabled", value >= max);
    }

    if (Number.isNaN(value)) {
      this.input.value = "1";
    }
  }
}

if (!window.customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}


class ReviewProduct extends HTMLElement {
  constructor() {
    super();

    this.section = this.closest(".main-product__content");
    this.productHandle = this.dataset.productHandle;
    this.type = this.dataset.type;
    this.class = this.dataset.class || "";

    this.fetchDataReviewProduct();
    this.watchJudgemeReviewWidget();
  }

  fetchDataReviewProduct() {
    if (!this.classList.contains("review-product-added")) {
      return;
    }

    const productWidget = this.querySelector(".product-review-json").innerHTML;
    const parsedWidget = new DOMParser().parseFromString(productWidget, "text/html").querySelector(".jdgm-prev-badge");

    if (!parsedWidget) {
      return;
    }

    const reviewsText = parsedWidget.innerText;
    const score = parsedWidget.dataset.averageRating;
    const scoreFormatted = score.slice(0, score.length - 1);
    const ratingPercentage = (score / 5) * 100;

    this.classList.remove("review-product-added");

    const filledStar = `
      <svg width="21" height="21" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
        <path d="M9.58332 3.32332L10.9443 7.39707L15.2981 7.47424L16.082 7.48814L15.4524 7.95361L11.9983 10.507L13.2707 14.6726L13.4994 15.4214L12.8622 14.9665L9.36632 12.4705L5.79807 14.9675L5.15554 15.4172L5.39166 14.6695L6.68497 10.5742L3.20785 7.95258L2.58203 7.48072L3.36625 7.47424L7.65996 7.43876L9.07896 3.32125L9.33468 2.5791L9.58332 3.32332Z" fill="rgb(var(--color-rating))"/>
      </svg>
    `;

    const notFilledStar = `
      <svg width="21" height="21" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0">
        <path d="M9.58332 3.32332L10.9443 7.39707L15.2981 7.47424L16.082 7.48814L15.4524 7.95361L11.9983 10.507L13.2707 14.6726L13.4994 15.4214L12.8622 14.9665L9.36632 12.4705L5.79807 14.9675L5.15554 15.4172L5.39166 14.6695L6.68497 10.5742L3.20785 7.95258L2.58203 7.48072L3.36625 7.47424L7.65996 7.43876L9.07896 3.32125L9.33468 2.5791L9.58332 3.32332Z" fill="rgba(var(--color-text), 0.1)"/>
      </svg>
    `;

    let markup = "";

    if (scoreFormatted !== "0.0") {
      markup = `
        <div class="product-review-widget inline-flex flex-wrap align-center lh-1 ${ this.type === 'compact' ? 'gap-5 fs-10' : 'gap-10 fs-14' } ${ this.class }" style="--rating-percentage: ${ratingPercentage}%;">
          <span class="relative inline-flex align-center">
            <span class="inline-flex align-center review-stars review-stars--filled">
              ${filledStar}
              ${filledStar}
              ${filledStar}
              ${filledStar}
              ${filledStar}
            </span>
            
            <span class="inline-flex align-center review-stars review-stars--grey">
              ${notFilledStar}
              ${notFilledStar}
              ${notFilledStar}
              ${notFilledStar}
              ${notFilledStar}
            </span>
          </span>
          
          <span class="inline-flex flex-wrap ${ this.type === 'compact' ? 'gap-7' : 'gap-10' }">
            ${scoreFormatted}
            <span class="color-bg-text-30 w-1"></span>
            <span class="product-review-widget__text">${reviewsText}</span>
          </span>
        </div>
      `;
    }

    this.innerHTML = markup;
  }

  watchJudgemeReviewWidget() {
    const widget = this.section?.querySelector(".jdgm-preview-badge");

    if (!widget) {
      return;
    }

    widget.closest(".shopify-block")?.classList.add("!hidden");

    const observer = new MutationObserver((mutationList, observer) => {
      const text = widget.querySelector(".jdgm-prev-badge__text");

      if (text && text.innerText !== "") {
        const blockText = this.querySelector(".product-review-widget__text");

        blockText.innerText = text.innerText;
      }
    });

    observer.observe(widget, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
}

if (!window.customElements.get("review-product")) {
  customElements.define("review-product", ReviewProduct);
}


class ScrollingArea extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector(".scrolling-area__content");

    if (!this.content) {
      return;
    }

    this.handleScroll();
    this.handleResize();

    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
    this.handleResizeListener = theme.helpers.throttle(this.handleResize.bind(this));
  }

  connectedCallback() {
    this.content.addEventListener("scroll", this.handleScrollListener, { passive: true });

    window.addEventListener("resize", this.handleResizeListener, { passive: true });
  }

  disconnectedCallback() {
    this.content.removeEventListener("scroll", this.handleScrollListener);

    window.removeEventListener("resize", this.handleResizeListener);
  }

  handleScroll() {
    const maxScrollLeft = this.content.scrollWidth - this.content.clientWidth;

    if (this.content.scrollLeft < 2) {
      this.classList.remove("scrolling-area--left-shadow");
      this.classList.add("scrolling-area--right-shadow");
    } else if (this.content.scrollLeft >= maxScrollLeft) {
      this.classList.add("scrolling-area--left-shadow");
      this.classList.remove("scrolling-area--right-shadow");
    } else {
      this.classList.add("scrolling-area--left-shadow");
      this.classList.add("scrolling-area--right-shadow");
    }
  }

  handleResize() {
    if (window.innerWidth > this.content.scrollWidth) {
      this.classList.remove("scrolling-area--left-shadow");
      this.classList.remove("scrolling-area--right-shadow");
    } else {
      this.handleScroll();
    }
  }
}

if (!window.customElements.get("scrolling-area")) {
  customElements.define("scrolling-area", ScrollingArea);
}


class BackToTop extends HTMLButtonElement {
  constructor() {
    super();

    this.handleScrollListener = theme.helpers.throttle(this.updateScrollPercentage.bind(this));

    this.addEventListener("click", this.backToTop.bind(this));
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScrollListener, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScrollListener);
  }

  backToTop() {
    if (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  updateScrollPercentage() {
    const documentElement = document.documentElement;
    const body = document.body;
    const scrollHeight = documentElement.scrollHeight || body.scrollHeight;
    const scrollTop = documentElement.scrollTop || body.scrollTop;
    const clientHeight = documentElement.clientHeight || body.clientHeight;
    const percentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    const formattedPercentage = `${percentage.toFixed(2)}%`;
    const shouldBeVisible = scrollTop > 200;

    this.style.setProperty("--custom-height", formattedPercentage);

    if (this._isVisible !== shouldBeVisible) {
      this.classList.toggle("visible", shouldBeVisible);
      this._isVisible = shouldBeVisible;
    }
  }
}

if (!window.customElements.get("back-to-top")) {
  customElements.define("back-to-top", BackToTop, { extends: "button" });
}


class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
    this.items = this.querySelectorAll("a");
    this.select = this.querySelector("select");

    this.items.forEach((item) => {
      item.addEventListener("click", this.onItemClick.bind(this));
    });

    if (this.select) {
      this.adjustSelectWidth();

      this.select.addEventListener("change", this.onSelectChange.bind(this));
      window.addEventListener("resize", theme.helpers.throttle(this.adjustSelectWidth.bind(this)), { passive: true });
    }
  }

  onItemClick(event) {
    event.preventDefault();

    this.input.value = event.currentTarget.dataset.value;

    if (this.form) {
      this.form.submit();
    }
  }

  onSelectChange() {
    this.input.value = this.select.value;

    if (this.form) {
      this.form.submit();
    }
  }

  adjustSelectWidth() {
    const tempDiv = document.createElement("div");
    const tempSpan = document.createElement("span");

    tempSpan.style.visibility = "hidden";
    tempSpan.style.whiteSpace = "nowrap";
    tempSpan.style.font = getComputedStyle(this.select).font;
    tempSpan.classList.add("ps-45", "pe-45");
    tempSpan.innerText = this.select.options[this.select.selectedIndex].text;

    tempDiv.appendChild(tempSpan);
    document.body.appendChild(tempDiv);

    const width = tempSpan.offsetWidth;

    document.body.removeChild(tempDiv);

    this.select.style.width = `${width}px`;
  }
}

if (!window.customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}


class CollapsibleBlock extends HTMLDetailsElement {
  constructor() {
    super();

    this.summaryElement = this.querySelector("summary");
    this.trigger = this.getAttribute("trigger") || "click";

    this.setAttribute("aria-expanded", this.hasAttribute("open") ? "true" : "false");

    if (this.trigger === "hover") {
      this.summaryElement.addEventListener("click", this.openUrl.bind(this));
      this.summaryElement.addEventListener("mouseenter", this.openSelector.bind(this));
      this.addEventListener("mouseleave", this.openSelector.bind(this));
    } else {
      this.summaryElement.addEventListener("click", this.openSelector.bind(this));
    }

    this.summaryElement.addEventListener("focus", this.openSelector.bind(this));

    document.addEventListener("focusin", (evt) => {
      const disclosures = [];
      let activeElement = document.activeElement;

      while (activeElement) {
        if (activeElement.tagName === "DISCLOSURE-ITEM") {
          disclosures.push(activeElement);
        }

        activeElement = activeElement.parentElement;
      }

      disclosures.forEach((disclosure) => {
        disclosure.openSelector(evt, true);
      });
    });
  }

  openSelector(evt, hideForce) {
    if (evt.type === "mouseenter" && this.classList.contains("active")) {
      return;
    }

    if (evt.type === "mouseleave" && !this.classList.contains("active")) {
      return;
    }

    if (["mouseenter", "mouseleave", "focus", "focusin"].includes(evt.type)) {
      this.setAttribute("open", "");
    } else {
      this.removeAttribute("open");
    }

    const target = evt.currentTarget || evt.target;
    const parent = target?.parentElement || this;

    if (!target || !parent) {
      return;
    }

    this.setAttribute("aria-expanded", "true");

    slideAnimation({
      target: parent.querySelector(".collapsible-content"),
      parent: this,
      animationType: hideForce ? "slideUp" : "slideToggle",
    });
  }

  openUrl() {
    const url = this.dataset.url;

    if (url) {
      window.location.href = url;
    }
  }
}

if (!window.customElements.get("collapsible-block")) {
  customElements.define("collapsible-block", CollapsibleBlock, { extends: "details" });
}


class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();

    this.initLoadMore();

    if (this.classList.contains("collection-infinite-scroll")) {
      const link = this.querySelector("a");

      link?.addEventListener("click", (e) => {
        const items = document.querySelectorAll(".collections-list .collection-item.grid-custom-item");

        items.forEach((item) => {
          item.classList.remove("hidden");
        });

        this.remove();
      }, false);
    }
  }

  initLoadMore() {
    const loadMoreActions = this.querySelectorAll(".load-more-actions");

    loadMoreActions.forEach((loadMore) => {
      if (loadMore.classList.contains("infinite-scrolling")) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio === 1) {
              this.loadMoreItem(loadMore);
            }
          });
        }, { threshold: 1.0 });

        observer.observe(loadMore);
      } else {
        loadMore.addEventListener("click", (event) => {
          event.preventDefault();

          const target = event.currentTarget;

          this.loadMoreItem(target);
        }, false);
      }
    });
  }

  loadMoreItem(target) {
    const loadMoreUrl = target.getAttribute("href");

    this.toggleLoading(target, true);

    fetch(`${loadMoreUrl}`).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    }).then((responseText) => {
      const resultNodes = new DOMParser().parseFromString(responseText, "text/html");
      const resultNodesHtml = resultNodes.querySelectorAll(".load-more-lists .load-more-lists");

      resultNodesHtml.forEach((prodNode) => {
        document.querySelector(".load-more-lists").appendChild(prodNode);
      });

      const loadMoreActions = resultNodes.querySelector(".load-more-actions");

      if (loadMoreActions) {
        target.setAttribute("href", loadMoreActions.getAttribute("href"));
      } else {
        target.remove();
      }

      this.toggleLoading(target, false);

      document.dispatchEvent(new CustomEvent("hover-button:apply"));
    }).catch((error) => {
      throw error;
    });
  }

  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? "add" : "remove";

      event.classList[method]("loading");
    }
  }
}

if (!window.customElements.get("load-more-button")) {
  customElements.define("load-more-button", PaginateLoadmore);
}


class TermsConditions extends ModalBase {
  constructor() {
    super();

    this.checkbox = this.querySelector(".terms-conditions__checkbox");
    this.checkout = this.closest(".cart-drawer__footer, .main-cart")?.querySelector(".button-checkout");

    this.init();
  }

  connectedCallback() {
    this.checkbox = this.querySelector(".terms-conditions__checkbox");
    this.checkout = this.closest(".cart-drawer__footer, .main-cart")?.querySelector(".button-checkout");

    this.init();
  }

  init() {
    if (!this.checkbox) {
      return;
    }

    if (theme.helpers.getCookie("terms-conditions")) {
      this.checkbox.setAttribute("checked", "");
      this.checkout?.removeAttribute("disabled");
    }

    this.checkbox.addEventListener("change", (event) => {
      if (event.currentTarget.checked) {
        this.checkout?.removeAttribute("disabled");

        theme.helpers.setCookie("terms-conditions", 1, 1);
      } else {
        this.checkout?.setAttribute("disabled", "");

        theme.helpers.deleteCookie("terms-conditions");
      }
    });
  }
}

if (!window.customElements.get("terms-conditions")) {
  customElements.define("terms-conditions", TermsConditions);
}


class SmartStickyBlock extends HTMLElement {
  constructor() {
    super();

    this.stickyHeader = document.querySelector(".header-section--sticky-always .header");
    this.lastScrollY = window.scrollY;
    this.viewHeight = window.innerHeight;
    this.elementHeight = this.offsetHeight;
    this.initialOffset = parseInt(this.dataset.shift || "20", 10);
    this.bottomLimit = this.elementHeight < this.viewHeight ? this.initialOffset : 0;

    window.addEventListener("scroll", theme.helpers.throttle(this.updatePosition.bind(this)));
  }

  calculateStickiness() {
    const maxTop = this.viewHeight - this.elementHeight - this.bottomLimit;
    const styleTop = parseInt(getComputedStyle(this).top, 10);
    const topGap = this.stickyHeader ? this.stickyHeader.clientHeight + this.initialOffset : this.initialOffset;
    const scrollingUp = window.scrollY < this.lastScrollY;
    const targetPosition = this.elementHeight + topGap + this.bottomLimit;

    if (targetPosition > this.viewHeight) {
      if (scrollingUp) {
        if (styleTop < topGap) {
          this.style.top = `${styleTop + (this.lastScrollY - window.scrollY)}px`;
        } else if (styleTop !== topGap) {
          this.style.top = `${topGap}px`;
        }
      } else {
        if (styleTop > maxTop) {
          this.style.top = `${styleTop - (window.scrollY - this.lastScrollY)}px`;
        } else if (styleTop !== maxTop) {
          this.style.top = `${maxTop}px`;
        }
      }
    } else {
      this.style.top = `${topGap}px`;
    }

    this.lastScrollY = window.scrollY;
  }

  updatePosition() {
    this.viewHeight = window.innerHeight;
    this.elementHeight = this.offsetHeight;

    this.calculateStickiness();
  }
}

if (!customElements.get("smart-sticky-block")) {
  customElements.define("smart-sticky-block", SmartStickyBlock);
}


class BenefitsSection extends HTMLElement {
  constructor() {
    super();

    this.blocks = [];
    this.firstBlocks = [];
    this.secondBlocks = [];
    this.shapes = [];
    this.animations = [];

    Motion.inView(this, () => {
      this.classList.add("visible");
    }, {
      margin: "-25% 0px -25% 0px"
    });

    this.animateBlocksOnScroll();

    document.addEventListener("breakpoint:lg:match", this.animateBlocksOnScroll.bind(this));
    document.addEventListener("breakpoint:lg:unmatch", this.animateBlocksOnScroll.bind(this));

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.animateBlocksOnScroll.bind(this));
      document.addEventListener("shopify:section:unload", this.animateBlocksOnScroll.bind(this));
    }
  }

  animateBlocksOnScroll() {
    if (theme.params.isMotionReduced) {
      return;
    }

    const scrollOptions = {
      target: this,
      offset: [
        [0, 1], [1, 0]
      ]
    };

    // Reset all animations
    this.animations?.forEach((animation) => {
      animation();
    });

    this.animations = [];

    this.blocks = this.querySelectorAll(".grid.grid-cols .grid-custom-item, .benefits__shapes");

    this.blocks.forEach((block) => {
      block.getAnimations().forEach(animation => animation.cancel());

      block.style.removeProperty("transform");

      block.style.transform = "translateY(0)";
    });

    if (theme.config.isLargeQuery) {
      this.firstBlocks = this.querySelectorAll(".grid.grid-cols .grid-custom-item:nth-of-type(2n-1)");
      this.secondBlocks = this.querySelectorAll(".grid.grid-cols .grid-custom-item:nth-of-type(2n)");
      this.shapes = this.querySelector(".benefits__shapes");

      this.firstBlocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(-50px)", "translateY(75px)"]
            }), scrollOptions
          )
        );
      });

      this.secondBlocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(50px)", "translateY(-75px)"]
            }), scrollOptions
          )
        );
      });

      this.animations.push(
        Motion.scroll(
          Motion.animate(this.shapes, {
            transform: ["translate(-50%) scale(0.85)", "translate(-50%) scale(1.15)"]
          }), scrollOptions
        )
      );
    }
  }
}

if (!window.customElements.get("benefits-section")) {
  customElements.define("benefits-section", BenefitsSection);
}


class CollectionTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".collection-tabs__tab");
    this.productBlocks = this.querySelectorAll(".collection-tabs__products");

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const blockId = tab.dataset.blockId;

        this.showContent(blockId);

        this.tabs.forEach((innerTab) => {
          innerTab.classList.remove("button-primary");
          innerTab.classList.add("button-outline");
          innerTab.removeAttribute("disabled");
        });

        tab.classList.add("button-primary");
        tab.classList.remove("button-outline");
        tab.setAttribute("disabled", "disabled");
      });
    });
  }

  showContent(blockId) {
    this.productBlocks.forEach((productBlock) => {
      productBlock.classList.add("collection-tabs__products--refreshing");

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("collection-tabs__products--hidden");
        } else {
          productBlock.classList.add("collection-tabs__products--hidden");
        }

        productBlock.classList.add("animated-blocks--hide-instantly");
        productBlock.classList.remove("visible");
        productBlock.classList.remove("collection-tabs__products--refreshing");
      }, 300);

      setTimeout(() => {
        if (productBlock.dataset.blockId === blockId) {
          productBlock.classList.remove("animated-blocks--hide-instantly");
          productBlock.classList.add("visible");
        }
      }, 500);
    });
  }
}

if (!window.customElements.get("collection-tabs")) {
  customElements.define("collection-tabs", CollectionTabs);
}


class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.closest(".countdown-timer");

    this.settings = theme.helpers.safelyParseJson(this.getAttribute("settings"));

    this.showIcon = this.settings?.showIcon || false;
    this.endTime = this.settings?.endTime || "";
    this.format = this.settings?.format || "dd:hh:mm:ss";
    this.minutesLeft = this.settings?.minutesLeft || "";
    this.hideTimerWhenDateElapses = this.settings?.hideTimerWhenDateElapses || false;
    this.type = this.settings?.type || "";
    this.timeoutMessage = this.settings?.timeoutMessage || "";
    this.daysLabel = this.settings?.daysLabel || "";
    this.hoursLabel = this.settings?.hoursLabel || "";
    this.minutesLabel = this.settings?.minutesLabel || "";
    this.secondsLabel = this.settings?.secondsLabel || "";

    this.interval = null;

    Motion.inView(this, () => {
      this.init();
    });
  }

  init() {
    if (this.type !== "flipdown") {
      const countdownAppend = this.querySelector(".countdown-inner");

      if (countdownAppend) {
        countdownAppend.innerHTML = this.appendChildHtml().innerHTML;
      } else {
        this.innerHTML = this.appendChildHtml().innerHTML;
      }
    }

    let isoDate = "";

    if (this.endTime) {
      if (this.isISODate(this.endTime)) {
        isoDate = this.endTime;
      } else {
        if (this.isValidDate(this.endTime)) {
          const dateParts = this.endTime.split("-");

          isoDate = `${dateParts[2]}-${dateParts[0].padStart(2, "0")}-${dateParts[1].padStart(2, "0")}T00:00:00Z`;
        }
      }
    }

    this.mainFunction(isoDate);
  }

  mainFunction(isoDate) {
    let timeLeft = {};

    const calculateTimeLeft = (difference) => {
      let timeLeft = {};

      if (this.format.includes("dd")) {
        timeLeft.days = Math.floor(difference / (1000 * 60 * 60 * 24));
      }

      if (this.format.includes("hh")) {
        if (this.format.includes("dd")) {
          timeLeft.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        } else {
          timeLeft.hours = Math.floor(difference / (1000 * 60 * 60));
        }
      }

      if (this.format.includes("mm")) {
        if (this.format === "mm:ss") {
          timeLeft.minutes = Math.floor(difference / 1000 / 60);
        } else {
          timeLeft.minutes = Math.floor((difference / 1000 / 60) % 60);
        }
      }

      if (this.format.includes("ss")) {
        timeLeft.seconds = Math.floor((difference / 1000) % 60);
      }

      return timeLeft;
    };

    if (Date.parse(isoDate) || this.minutesLeft) {
      const now = new Date();
      let deadline = new Date(isoDate);

      if (this.minutesLeft) {
        deadline = new Date(Date.now() + parseInt(this.minutesLeft) * 60000);
      }

      if (this.type === "flipdown") {
        if (now > deadline) {
          this.onTimerEnd();
        } else {
          new FlipDown(deadline / 1000, this, {
            headings: [this.daysLabel, this.hoursLabel, this.minutesLabel, this.secondsLabel]
          }).start().ifEnded(() => {
            this.onTimerEnd();
          });
        }
      } else {
        const updateCountdown = () => {
          const now = new Date();
          const difference = deadline - now;

          if (difference > 0) {
            timeLeft = calculateTimeLeft(difference);
          } else {
            timeLeft = calculateTimeLeft(0);
          }

          if (timeLeft.days > 0 || timeLeft.hours > 0 || timeLeft.minutes > 0 || timeLeft.seconds > 0) {
            Object.entries(timeLeft).forEach(([key, value]) => {
              const unit = this.querySelector(`.${key}`);

              if (unit) {
                unit.innerHTML = value.toString().padStart(2, "0");
              }
            });
          } else {
            Object.entries(timeLeft).forEach(([key, value]) => {
              const unit = this.querySelector(`.${key}`);

              if (unit) {
                unit.innerHTML = "00";
              }
            });

            this.onTimerEnd();

            clearInterval(this.interval);
          }

          this.classList.remove("hidden");
        };

        this.interval = setInterval(updateCountdown, 1000);

        updateCountdown();
      }
    } else {
      timeLeft = calculateTimeLeft(0);

      Object.entries(timeLeft).forEach(([key, value]) => {
        const unit = this.querySelector(`.${key}`);

        if (unit) {
          unit.innerHTML = value.toString().padStart(2, "0");
        }
      });
    }
  }

  onTimerEnd() {
    if (this.hideTimerWhenDateElapses) {
      if (this.wrapper) {
        this.wrapper.remove();
      } else {
        this.remove();
      }

      const productGridWrapper = this.closest(".product-item--has-countdown");

      if (productGridWrapper) {
        productGridWrapper.classList.remove("product-item--has-countdown");
      }
    } else if (this.timeoutMessage) {
      this.innerHTML = this.timeoutMessage;

      this.closest(".countdown-timer-wrapper")?.classList.remove("shrink-0");
    }
  }

  appendChildHtml() {
    const container = document.createElement("div");

    container.innerHTML = `${ this.showIcon ? `
      <div class="inline-flex me-5">
        <svg width="16" height="16" class="shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" color="currentColor" fill="none">
          <path d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M5 19L3 21M19 19L21 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 3.5697L19.5955 3.27195C20.4408 2.84932 20.7583 2.89769 21.4303 3.5697C22.1023 4.2417 22.1507 4.55924 21.728 5.4045L21.4303 6M5 3.5697L4.4045 3.27195C3.55924 2.84932 3.2417 2.89769 2.5697 3.5697C1.89769 4.2417 1.84932 4.55924 2.27195 5.4045L2.5697 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M12 9.5V13.5L14 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 3.5V2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 2H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>` : "" }${ !this.minutesLeft ? `${ this.format.includes("dd") ? `<div class="countdown-timer__block"><span class="days countdown-timer__counter"></span><span class="countdown-timer__text"> ${ this.daysLabel }</span></div>` : "" }${ this.format.includes("hh") ? `<div class="countdown-timer__block"><span class="hours countdown-timer__counter"></span><span class="countdown-timer__text"> ${ this.hoursLabel }</span></div>` : ""}` : ""}
      <div class="countdown-timer__block"><span class="minutes countdown-timer__counter"></span><span class="countdown-timer__text"> ${ this.minutesLeft ? "m" : this.minutesLabel }</span></div>
      <div class="countdown-timer__block"><span class="seconds countdown-timer__counter"></span><span class="countdown-timer__text"> ${ this.minutesLeft ? "s" : this.secondsLabel }</span></div>
    `;

    return container;
  }

  isISODate(dateString) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/.test(dateString);
  }

  isValidDate(dateString) {
    return /^\d{2}-\d{2}-\d{4}$/.test(dateString);
  }
}

if (!window.customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}


class CounterHighlights extends HTMLElement {
  constructor() {
    super();

    this.numbers = this.querySelectorAll(".counter-highlights__number");

    Motion.inView(this, () => {
      this.init();
    });
  }

  init() {
    this.numbers.forEach((number) => {
      const duration = Number.parseFloat(number.dataset.duration) || 2;
      const endValue = Number.parseInt(number.dataset.endValue);

      if (Number.isInteger(endValue)) {
        Motion.animate(0, endValue, {
          duration: duration,
          ease: "circOut",
          onUpdate: (latest) => (number.innerHTML = Math.round(latest)),
        })
      }
    });
  }
}

if (!window.customElements.get("counter-highlights")) {
  customElements.define("counter-highlights", CounterHighlights);
}


class FAQSection extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll("[is='collapsible-block']");

    this.allowOneOpenedTab();
  }

  allowOneOpenedTab() {
    this.tabs.forEach((tab) => {
      const summary = tab.querySelector("summary");

      summary.addEventListener("focus", (evt) => {
        this.tabs.forEach((innerTab) => {
          if (tab === innerTab || !innerTab.classList.contains("active")) {
            return;
          }

          slideAnimation({
            target: innerTab.querySelector(".collapsible-content"),
            parent: innerTab,
            animationType: "slideUp",
            forceAnimating: true
          });
        });
      });
    });
  }
}

if (!window.customElements.get("faq-section")) {
  customElements.define("faq-section", FAQSection);
}


class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector(".image-comparison__container");
    this.button = this.querySelector(".image-comparison__button");
    this.overlay = this.querySelector(".image-comparison__overlay");

    this.handleInteractionStartListener = this.handleInteractionStart.bind(this);
    this.handleInteractionEndListener = this.handleInteractionEnd.bind(this);
    this.handleMoveListener = this.handleMove.bind(this);
    this.handleResizeListener = theme.helpers.throttle(this.handleResize.bind(this));

    Motion.inView(this, () => {
      this.style.setProperty("--container-width", `${this.container.getBoundingClientRect().width}px`);

      setTimeout(() => {
        this.classList.add("animate", "animating");

        setTimeout(() => {
          this.classList.remove("animating");
        }, 1400);
      }, 800);
    });
  }

  connectedCallback() {
    window.addEventListener("resize", this.handleResizeListener, { passive: true });

    this.button.addEventListener("touchstart", this.handleInteractionStartListener, { passive: true });
    this.button.addEventListener("mousedown", this.handleInteractionStartListener, { passive: true });

    this.button.addEventListener("touchend", this.handleInteractionEndListener, { passive: true });
    this.button.addEventListener("mouseup", this.handleInteractionEndListener, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResizeListener);

    this.button.removeEventListener("touchstart", this.handleInteractionStartListener);
    this.button.removeEventListener("mousedown", this.handleInteractionStartListener);

    this.button.removeEventListener("touchend", this.handleInteractionEndListener);
    this.button.removeEventListener("mouseup", this.handleInteractionEndListener);
  }

  handleResize() {
    this.style.setProperty("--container-width", `${this.container.getBoundingClientRect().width}px`);
  }

  handleInteractionStart() {
    window.bodyScrollLock.disableBodyScroll(document.body);

    document.documentElement.classList.add("page-no-scroll");

    document.addEventListener("touchmove", this.handleMoveListener, { passive: true });
    document.addEventListener("mousemove", this.handleMoveListener, { passive: true });
  }

  handleInteractionEnd() {
    window.bodyScrollLock.clearAllBodyScrollLocks();

    document.documentElement.classList.remove("page-no-scroll");

    document.removeEventListener("touchmove", this.handleMoveListener);
    document.removeEventListener("mousemove", this.handleMoveListener);
  }

  handleMove(evt) {
    let cursorPosition = Math.max(0, this.getCursorPosition(evt));

    if (cursorPosition > this.overlay.offsetWidth) {
      cursorPosition = this.overlay.offsetWidth;
    }

    this.moveButton(cursorPosition);
  }

  getCursorPosition(evt) {
    const event = evt.changedTouches ? evt.changedTouches[0] : evt;
    const overlayDimensions = this.overlay.getBoundingClientRect();

    return event.pageX - overlayDimensions.left - window.pageXOffset;
  }

  moveButton(cursorPosition) {
    if (!this.button) {
      return;
    }

    const position = cursorPosition / this.overlay.offsetWidth * 100;

    this.container.style.setProperty("--percent", `${position}%`);
  }
}

if (!window.customElements.get("image-comparison")) {
  customElements.define("image-comparison", ImageComparison);
}


class MobileNavigationBar extends HTMLElement {
  constructor() {
    super();

    this.headerSection = document.querySelector(".header-section");

    document.body.classList.add("mobile-navigation-bar-enabled");

    this.setBarVisibility();

    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScrollListener, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScrollListener);

    document.body.classList.remove("mobile-navigation-bar-enabled");
    document.body.classList.remove("mobile-navigation-bar-visible");
  }

  handleScroll() {
    this.setBarVisibility();
  }

  setBarVisibility() {
    const scrollPosition = window.scrollY;
    const headerSection = this.headerSection;

    const isHeaderStickyAlways = headerSection?.classList.contains("header-section--sticky-always");
    const isHeaderStickyOnScroll = headerSection?.classList.contains("header-section--sticky-on-scroll-up");
    const isHeaderHidden = headerSection?.classList.contains("header-hidden");
    const isHeaderStickyOnScrollAndHidden = isHeaderStickyOnScroll && isHeaderHidden;
    const isHeaderNotSticky = !isHeaderStickyAlways && !isHeaderStickyOnScroll;

    const isNearBottom = scrollPosition > (document.body.offsetHeight - window.innerHeight - 260);
    const shouldBeVisible = isNearBottom || (scrollPosition > 200 && (isHeaderStickyAlways || isHeaderStickyOnScrollAndHidden || isHeaderNotSticky));

    if (this.classList.contains("visible") !== shouldBeVisible) {
      this.classList.toggle("visible", shouldBeVisible);
      document.body.classList.toggle("mobile-navigation-bar-visible", shouldBeVisible);
    }
  }
}

if (!window.customElements.get("mobile-navigation-bar")) {
  customElements.define("mobile-navigation-bar", MobileNavigationBar);
}


class NewsletterPopup extends ModalBase {
  constructor() {
    super();

    if (window.location.pathname === "/challenge" || !theme.helpers.cookiesEnabled()) {
      return;
    }

    this.settings = theme.helpers.safelyParseJson(this.getAttribute("settings")) || {};

    this.isTestMode = this.settings.displayMode === "test";
    this.frequency = this.settings.frequency || 10;
    this.cookieName = "newsletter-popup:closed";

    this.content = this.querySelector(".modal-content-markup");
    this.customClass = "newsletter-popup";

    if (this.classList.contains("newsletter-popup-section--has-image")) {
      this.customClass += " newsletter-popup--has-image";
    }

    if (!this.content) {
      return;
    }

    const existingModals = document.querySelectorAll(".modal.newsletter-popup");

    existingModals.forEach((modal) => {
      setTimeout(() => {
        modal.remove();
      }, 600)
    });

    this.init({
      customClass: this.customClass,
      content: this.content,
      id: "NewsletterPopup",
      transitionDuration: 1000,
      closeButtonPosition: "content",
      closeButtonContainerSelector:  ".newsletter-popup__content"
    });

    if (this.submitted) {
      setTimeout(() => {
        this.open(true);
      }, 1000)

      return;
    }

    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
    this.handleMouseLeaveListener = theme.helpers.throttle(this.handleMouseLeave.bind(this));

    if (this.isTestMode || !theme.helpers.getCookie(this.cookieName)) {
      this.setPopupVisibility();
    }
  }

  get submitted() {
    const popup = document.querySelector(".modal.newsletter-popup");

    return !!popup?.querySelector(".newsletter-popup__message");
  }

  handleScroll() {
    const body = document.body;
    const html = document.documentElement;
    const documentHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const scrollLimit = Math.floor((documentHeight / 100) * this.settings.scrollDepthPercentage);
    const visibleModal = document.querySelector(".newsletter-popup.modal--visible");

    if (window.scrollY > scrollLimit && !visibleModal) {
      this.open();
    }
  }

  handleMouseLeave(event) {
    const visibleModal = document.querySelector(".newsletter-popup.modal--visible");

    if (event.clientY < 0 && !visibleModal) {
      this.open();
    }
  }

  setPopupVisibility() {
    const visibleModals = document.querySelectorAll(".newsletter-popup.modal--visible");

    visibleModals.forEach((modal) => {
      modal.classList.remove("modal--visible");

      setTimeout(() => {
        modal.remove();
      }, 1000);
    });

    if (this.isTestMode) {
      if (Shopify && Shopify.designMode) {
        setTimeout(() => {
          this.open();
        }, 1000);
      }
    } else {
      if (this.settings.enableTimeTrigger) {
        setTimeout(() => {
          this.open();
        }, this.settings.timeTriggerTimeout);
      }

      if (this.settings.enableExitIntentTrigger) {
        document.removeEventListener("mouseleave", this.handleMouseLeaveListener);
        document.addEventListener("mouseleave", this.handleMouseLeaveListener);
      }

      if (this.settings.enableScrollDepthTrigger) {
        window.removeEventListener("scroll", this.handleScrollListener);
        window.addEventListener("scroll", this.handleScrollListener, { passive: true });
      }
    }
  }

  open(isSubmitted, activeElement = null) {
    if (!isSubmitted && !this.isTestMode && theme.helpers.getCookie(this.cookieName)) {
      return;
    }

    this.activeElement = activeElement;

    super.open(activeElement);
  }

  close() {
    if (this.isBusy) {
      return;
    }

    this.isBusy = true;

    this.modal.classList.add("modal--is-hiding");
    this.modal.classList.remove("modal--visible");

    const visibleModalsOrDrawers = document.querySelector(".modal.modal--visible, .drawer.open");

    if (!visibleModalsOrDrawers) {
      window.bodyScrollLock.clearAllBodyScrollLocks();

      document.documentElement.classList.remove("page-no-scroll");
    }

    setTimeout(() => {
      this.modal.classList.remove("modal--is-hiding");

      this.activeElement?.focus();
    }, 600);

    setTimeout(() => {
      this.activeElement?.focus();
    }, 50);

    this.isBusy = false;

    if (this.isTestMode) {
      theme.helpers.deleteCookie(this.cookieName);

      return;
    }

    theme.helpers.setCookie(this.cookieName, true, this.frequency);
  }
}

if (!window.customElements.get("newsletter-popup")) {
  customElements.define("newsletter-popup", NewsletterPopup);
}


class NewsletterPopupTrigger extends HTMLButtonElement {
  constructor() {
    super();

    this.modal = document.querySelector("newsletter-popup");

    if (this.modal) {
      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  handleClick() {
    theme.helpers.deleteCookie(this.modal.cookieName);

    this.modal.open(false, this);
  }
}

if (!window.customElements.get("newsletter-popup-trigger")) {
  customElements.define("newsletter-popup-trigger", NewsletterPopupTrigger, { extends: "button" });
}


class QuickView extends ModalBase {
  constructor() {
    super();
  }

  onThisClick() {
    if (this.hasAttribute("disabled")) {
      return;
    }

    if (window.innerWidth < 1025 && this.hasAttribute("data-mobile-disabled")) {
      return;
    }

    let customClass = this.dataset.customClass || "quickview";

    customClass = `${customClass} modal--loading`;

    this.classList.add("loading");

    super.init({
      customClass: customClass,
    });

    super.open(this);

    const modals = document.querySelectorAll(".modal.quickview");
    this.modal = modals[modals.length - 1];

    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const parsedHTML = new DOMParser().parseFromString(text, "text/html");
        const content = parsedHTML.querySelector(".product-quick-view__content");

        if (!content) {
          return;
        }

        const colorScheme = content.dataset.colorScheme;
        const colorSchemeDark = content.dataset.colorSchemeDark;
        const isDark = document.documentElement.getAttribute('data-color-mode') === 'dark';
        const activeScheme = (isDark && colorSchemeDark) ? colorSchemeDark : colorScheme;
        const modalContainer = this.modal?.querySelector(".modal__content");

        if (modalContainer) {
          modalContainer.insertAdjacentElement("beforeend", content);
        }

        this.enableScrolling();

        this.modal.classList.add(activeScheme);

        if (colorScheme && colorSchemeDark) {
          this.modal.setAttribute('data-color-mode-light', colorScheme);
          this.modal.setAttribute('data-color-mode-dark', colorSchemeDark);
        }

        // This handles the modal's own top-level scheme above, but
        // nested blocks with their own independent light/dark scheme
        // pair (e.g. a collapsible tab's own Color scheme — Dark mode
        // setting) just arrived in the DOM and were never scanned by
        // header.liquid's one-time [data-color-mode-light] pass — that
        // only runs at DOMContentLoaded / toggle click, so this content,
        // fetched and inserted after the fact, was stuck on its
        // server-rendered light class regardless of the active mode.
        if (window.BenitronicaColorMode) {
          window.BenitronicaColorMode.apply(window.BenitronicaColorMode.current());
        }

        this.loadScripts(content);

        document.dispatchEvent(new CustomEvent("hover-button:apply"));

        setTimeout(() => {
          if (this.modal) {
            this.modal.classList.remove("modal--loading");
          }
        }, 200);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        Shopify.PaymentButton.init();

        const mutationObserver = new MutationObserver((mutations) => {
          const acceleratedCheckoutStyles = document.getElementById("shopify-accelerated-checkout");

          if (acceleratedCheckoutStyles) {
            acceleratedCheckoutStyles?.remove();

            mutationObserver.disconnect();
          }
        });

        mutationObserver.observe(document.head, {
          childList: true,
          subtree: true
        });

        this.classList.remove("loading");

        theme.accessibility.trapFocus(this.modal, this.focusElement);
      });
  }

  loadScripts(html) {
    const scripts = html.querySelectorAll("script");

    scripts.forEach((script) => {
      const addedScripts = Array.from(document.querySelectorAll(`script[src='${script.src}'], script[src='${script.src.replace("https:", "")}']`)).filter((script) => {
        return !html.contains(script);
      });

      if (addedScripts.length) {
        return;
      }

      const isModule = script.getAttribute("type") === "module";
      const newScript = document.createElement("script");

      newScript.src = script.src;
      newScript.textContent = script.textContent;

      if (isModule) {
        newScript.setAttribute("type", "module");
      }

      document.body.appendChild(newScript);
    });
  }

  enableScrolling() {
    const windowSizeQuery = window.matchMedia("screen and (min-width: 1024px)");

    if (windowSizeQuery.matches) {
      window.bodyScrollLock.enableBodyScroll(this.modal.querySelector(".modal__content") || this.modal);
      window.bodyScrollLock.disableBodyScroll(this.modal.querySelector(".main-product__content-wrapper") || this.modal);
    }

    windowSizeQuery.onchange = (query) => {
      if (query.matches) {
        window.bodyScrollLock.enableBodyScroll(this.modal.querySelector(".modal__content") || this.modal);
        window.bodyScrollLock.disableBodyScroll(this.modal.querySelector(".main-product__content-wrapper") || this.modal);
      } else {
        window.bodyScrollLock.enableBodyScroll(this.modal.querySelector(".main-product__content-wrapper") || this.modal);
        window.bodyScrollLock.disableBodyScroll(this.modal.querySelector(".modal__content") || this.modal);
      }
    };
  }
}


class QuickViewTrigger extends QuickView {
  constructor() {
    super();

    this.url = this.dataset.url;

    this.init();
  }

  init() {
    this.addEventListener("click", this.onThisClick.bind(this));
    this.addEventListener("keydown", this.handleKeyPress.bind(this));
  }

  handleKeyPress(evt) {
    if (evt.key === "Enter" || evt.key === " ") {
      evt.preventDefault();

      this.onThisClick(evt);
    }
  }
}

if (!window.customElements.get("quick-view-trigger")) {
  customElements.define("quick-view-trigger", QuickViewTrigger);
}


class RevealMediaWithTextOverlay extends HTMLElement {
  constructor() {
    super();

    this.sections = Array.from(this.querySelectorAll(".reveal-media-with-text-overlay__section"));
    this.sectionInners = this.querySelectorAll(".reveal-media-with-text-overlay__section .section__inner");

    this.updateHeightShift();
    this.init();

    document.addEventListener("breakpoint:sm:match", this.updateHeightShift.bind(this));
    document.addEventListener("breakpoint:sm:unmatch", this.updateHeightShift.bind(this));
  }

  init() {
    const headerElement = document.querySelector(".header-section--sticky-always");
    const headerHeight = headerElement ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0 : 0;
    const minScale = 0.92;

    Motion.scroll((progress) => {
      const sectionTop = this.getBoundingClientRect().top + window.scrollY - headerHeight;
      const scrollInSection = Math.max(0, window.scrollY - sectionTop);

      const sectionHeights = this.sections.map((section) => {
        return section.getBoundingClientRect().height - this.heightShift;
      });

      const currentSectionIndex = this.findMatchingIndex(scrollInSection, sectionHeights);
      const currentSection = this.sections[currentSectionIndex];

      let sectionInner, scaleValue;

      this.sectionInners.forEach((sectionInnerBlock, index) => {
        sectionInner = sectionInnerBlock;
        scaleValue = index < currentSectionIndex ? minScale : 1;

        Motion.animate(sectionInner, {
          transform: [`scale(${scaleValue})`]
        }, { duration: 0, fill: "forwards" });
      });

      if (currentSectionIndex + 1 === this.sections.length || !currentSection) {
        const firstSectionInner = this.sections[0].querySelector(".section__inner");

        Motion.animate(firstSectionInner, {
          transform: [`scale(1)`]
        }, { duration: 0, fill: "forwards" });

        return;
      }

      const currentSectionHeight = currentSection.getBoundingClientRect().height - this.heightShift;

      sectionInner = currentSection.querySelector(".section__inner");

      let scrolledInsideCurrentSection = scrollInSection;

      for (let i = 0; i < sectionHeights.length; i++) {
        const sectionHeight = sectionHeights[i];

        if (scrolledInsideCurrentSection - sectionHeight >= 0) {
          scrolledInsideCurrentSection -= sectionHeight;
        } else {
          break;
        }
      }

      scaleValue = 1 - (1 - minScale) * (scrolledInsideCurrentSection / currentSectionHeight);

      Motion.animate(sectionInner, {
        transform: [`scale(${scaleValue})`]
      }, { duration: 0, fill: "forwards" });
    }, {
      target: this,
      offset: [[0, 1], [1, 1]]
    });
  }

  updateHeightShift() {
    const borderRadius = Number.parseFloat(getComputedStyle(this).getPropertyValue("--border-radius"));
    const borderRadiusMultiplier = Number.parseInt(getComputedStyle(this).getPropertyValue("--border-radius-multiplier"));

    this.heightShift = borderRadius * borderRadiusMultiplier;
  }

  findMatchingIndex(value, arr) {
    let cumulativeSum = 0;

    for (let i = 0; i < arr.length; i++) {
      cumulativeSum += arr[i];

      if (cumulativeSum > value) {
        return i;
      }
    }

    return -1;
  }
}

if (!window.customElements.get("reveal-media-with-text-overlay")) {
  customElements.define("reveal-media-with-text-overlay", RevealMediaWithTextOverlay);
}


class ScrollingBanner extends HTMLElement {
  constructor() {
    super();

    if (theme.params.isMotionReduced) {
      return;
    }

    this.rows = this.querySelectorAll(".scrolling-banner__row");
    this.scrollingType = this.dataset.scrollingType;

    Motion.inView(this, this.init.bind(this), {
      margin: "150px 0px 150px 0px"
    });
  }

  init() {
    this.rows.forEach((row) => {
      const rowInner = row.querySelector(".scrolling-banner__row-inner");
      const direction = row.dataset.direction;
      const scrollingSpeed = row.dataset.scrollingSpeed || 15;

      if (rowInner.childElementCount === 1) {
        const childElement = rowInner.firstElementChild;
        const parentWidth = rowInner.getBoundingClientRect().width;
        const childElementWidth = childElement.getBoundingClientRect().width;
        const maximum = Math.ceil(parentWidth / childElementWidth) + 2;

        for (let i = 0; i < maximum; i++) {
          const clone = childElement.cloneNode(true);

          clone.setAttribute("aria-hidden", "true");
          rowInner.appendChild(clone);
        }

        const duration = scrollingSpeed * Math.min(2.5, childElementWidth / parentWidth);

        row.style.setProperty("--speed", `${duration}s`);
      }

      if (!theme.params.isTouchDevice && (this.scrollingType === "on-scroll" || this.scrollingType === "both")) {
        let translate = 30;

        if (direction === "right" || theme.params.isRtlDirection) {
          translate = -30;
        }

        Motion.scroll(
          Motion.animate(rowInner, {
            transform: [`translateX(${translate}%)`, "translateX(0)"]
          }, {
            easing: "linear"
          }),
          {
            target: rowInner,
            offset: ["start end", "end start"]
          }
        );
      }
    });
  }
}

if (!window.customElements.get("scrolling-banner")) {
  customElements.define("scrolling-banner", ScrollingBanner);
}


class ScrollingVerticalContent extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector(".scrolling-vertical-content__content");
    this.items = this.querySelectorAll(".scrolling-vertical-content__block");
    this.scrollingItems = this.querySelectorAll(".scrolling-vertical-content__block[data-scroll-speed]");
    this.slider = this.querySelector(".scrolling-vertical-content__blocks");

    this.calculateHeight();
    this.applyClassForVisibleItems();

    this.handleScrollListener = theme.helpers.throttle(this.handleScroll.bind(this));
    this.handleResizeListener = theme.helpers.throttle(this.handleResize.bind(this));
    this.handleSectionLoadListener = this.handleSectionLoad.bind(this);

    if (this.scrollingItems.length > 0) {
      this.scrollParallax();
      this.calculateHeight();
    }
  }

  connectedCallback() {
    window.addEventListener("resize", this.handleResizeListener, { passive: true });

    if (this.scrollingItems.length > 0) {
      window.addEventListener("scroll", this.handleScrollListener, { passive: true });
    }

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.handleSectionLoadListener);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResizeListener);

    if (this.scrollingItems.length > 0) {
      window.removeEventListener("scroll", this.handleScrollListener);
    }

    if (Shopify.designMode) {
      document.removeEventListener("shopify:section:load", this.handleSectionLoadListener);
    }
  }

  handleSectionLoad() {
    this.scrollParallax();
    this.calculateHeight();
  }

  handleScroll() {
    this.scrollParallax();
  }

  handleResize() {
    this.scrollParallax();
    this.calculateHeight();
  }

  applyClassForVisibleItems() {
    if (!this.content) {
      return;
    }

    Motion.inView(this, () => {
      this.classList.add("visible");
    });
  }

  scrollParallax() {
    const windowHeight = document.documentElement.clientHeight;
    const windowWidth = document.documentElement.clientWidth;

    if (windowWidth < 768 || windowWidth <= windowHeight) {
      return;
    }

    const sliderClientRect = this.slider.getBoundingClientRect();
    const sliderOffsetHeight = this.slider.offsetHeight;
    const halfDiff = (windowHeight - sliderOffsetHeight) / 2;
    const baseValue = sliderClientRect.y - halfDiff;
    const thresholdUpper = windowHeight * 2;

    this.scrollingItems.forEach((item, index) => {
      const elementY = item.getBoundingClientRect().y;
      const scrollFactor = +item.dataset.scrollSpeed;

      if (elementY < thresholdUpper && elementY > (item.offsetHeight + windowHeight) * -1) {
        const scrollingValue = (baseValue * scrollFactor) / 2;

        if (Math.abs(scrollingValue) < windowHeight) {
          item.style.transform = `translate3d(0, ${scrollingValue}px, 0)`;
        }
      }
    });
  }

  calculateHeight() {
    let height = 0;

    this.items.forEach((elm) => {
      const totalHeight = elm.offsetHeight + elm.offsetTop;

      if (totalHeight > height) {
        height = totalHeight;
      }
    });

    this.slider.style.height = `${height}px`;
  }
}

if (!window.customElements.get("scrolling-vertical-content")) {
  customElements.define("scrolling-vertical-content", ScrollingVerticalContent);
}


class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    this.productsContainer = this.querySelector(".shop-the-look__products");
    this.products = this.querySelectorAll(".shop-the-look__product");
    this.items = this.querySelectorAll(".shop-the-look__item-inner");
    this.carousel = this.querySelector(".shop-the-look__carousel");
    this.productsPosition = this.dataset.productsPosition;

    this.init();

    document.addEventListener("breakpoint:lg:match", this.animateProducts.bind(this));
    document.addEventListener("breakpoint:lg:unmatch", this.stopAnimatingProducts.bind(this));
  }

  init() {
    this.initItems();
    this.handleSlideChange();

    if (theme.config.isLargeQuery) {
      this.animateProducts();
    } else {
      this.stopAnimatingProducts();
    }
  }

  animateProducts() {
    if (theme.params.isMotionReduced || theme.params.isTouchDevice || theme.config.isSmallQuery || theme.config.isMediumQuery) {
      return;
    }

    let transformAnimation = ["perspective(15cm) rotateX(15deg) rotateY(5deg)", "perspective(15cm) rotateX(0deg) rotateY(5deg)"];

    if (this.productsPosition === "right") {
      transformAnimation = ["perspective(15cm) rotateX(15deg) rotateY(-5deg)", "perspective(15cm) rotateX(0deg) rotateY(-5deg)"];
    }

    this.productsAnimation = Motion.scroll(
      Motion.animate(this.productsContainer, {
        transform: transformAnimation
      }), {
        target: this,
        offset: [
          [0, 1], [1, 1]
        ]
      });
  }

  stopAnimatingProducts() {
    if (this.productsAnimation) {
      this.productsAnimation();
    }

    Motion.animate(this.productsContainer, {
      transform: ["perspective(1px) rotateX(0) rotateY(0)"]
    }, { duration: 0, fill: "forwards" });

    this.productsContainer.style.transform = "none";
  }

  initItems() {
    this.items.forEach((item) => {
      const itemParent = item.parentElement;
      const position = +itemParent.dataset.productPosition;

      item.addEventListener("mouseenter", () => {
        this.goToSlide(itemParent, position);
        this.showActiveProduct(itemParent);
      });

      item.addEventListener("mouseleave", () => {
        this.goToSlide(itemParent, position);
        this.showActiveProduct(itemParent);
      });

      item.addEventListener("focus", () => {
        this.goToSlide(itemParent, position);
        this.showActiveProduct(itemParent);
      });

      item.addEventListener("click", (e) => {
        e.preventDefault();

        this.goToSlide(itemParent, position);
        this.showActiveProduct(itemParent);
      });
    });
  }

  handleSlideChange() {
    this.carousel.addEventListener("carousel:beforeTransitionStart", (e) => {
      const activeIndex = e.target.globalSlide.activeIndex;

      this.items.forEach((item, index) => {
        const itemParent = item.parentElement;

        if (activeIndex === index) {
          itemParent.classList.add("active");
          item.setAttribute("aria-current", "true");
        } else {
          itemParent.classList.remove("active");
          item.setAttribute("aria-current", "false");
        }
      });
    });
  }

  goToSlide(currentItem, position) {
    this.carousel?.globalSlide.slideTo(position, 500);
  }

  showActiveProduct(currentItem) {
    this.products.forEach((product) => {
      product.classList.remove("active");
    });

    this.items.forEach((item) => {
      const itemParent = item.parentElement;
      const id = item.getAttribute("aria-controls");

      if (currentItem === itemParent) {
        const product = document.getElementById(id);

        itemParent.classList.add("active");
        item.setAttribute("aria-current", "true");

        product?.classList.add("active");
      } else {
        itemParent.classList.remove("active");
        item.setAttribute("aria-current", "false");
      }
    });
  }
}

if (!window.customElements.get("shop-the-look")) {
  customElements.define("shop-the-look", ShopTheLook);
}


class ShoppableMedia extends HTMLElement {
  constructor() {
    super();

    this.mediaPerRowDesktop = parseInt(this.dataset.mediaPerRowDesktop);
    this.videos = this.querySelectorAll("lazy-video");

    this.blocks = [];
    this.firstBlocks = [];
    this.secondBlocks = [];
    this.animations = [];

    this.playOnlyOneVideo();
    this.animateBlocksOnScroll();

    document.addEventListener("breakpoint:xs:match", this.animateBlocksOnScroll.bind(this));
    document.addEventListener("breakpoint:xs:unmatch", this.animateBlocksOnScroll.bind(this));
    document.addEventListener("breakpoint:lg:match", this.animateBlocksOnScroll.bind(this));
    document.addEventListener("breakpoint:lg:unmatch", this.animateBlocksOnScroll.bind(this));

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.animateBlocksOnScroll.bind(this));
      document.addEventListener("shopify:section:unload", this.animateBlocksOnScroll.bind(this));
    }
  }

  playOnlyOneVideo() {
    this.videos.forEach((video) => {
      video.addEventListener("is-playing", () => {
        theme.helpers.pauseAllMedia();
      });
    });
  }

  animateBlocksOnScroll() {
    if (theme.params.isMotionReduced) {
      return;
    }

    const scrollOptions = {
      target: this,
      offset: [
        [0, 1], [1, 0]
      ]
    };

    // Reset all animations
    this.animations?.forEach((animation) => {
      animation();
    });

    this.animations = [];

    this.blocks = this.querySelectorAll(".grid-cols .grid-custom-item > div");

    this.blocks.forEach((block) => {
      block.getAnimations().forEach(animation => animation.cancel());

      block.style.removeProperty("transform");
      block.style.transform = "translateY(0)";
    });

    if (theme.config.isMediumQuery && !theme.config.isExtraSmallQuery) {
      // 2 items per row always
      this.blocks = this.querySelectorAll(".grid-cols .grid-custom-item:nth-of-type(even) > div");

      this.blocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(0)", "translateY(-100px)"]
            }), scrollOptions
          )
         );
      });
    } else if (theme.config.isLargeQuery) {
      switch (this.mediaPerRowDesktop) {
        case 2:
          this.blocks = this.querySelectorAll(".grid-cols .grid-custom-item:nth-of-type(even) > div");

          break;

        default:
          this.blocks = [];
          this.firstBlocks = [];
          this.secondBlocks = [];

          break;
      }

      this.blocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(50px)", "translateY(-100px)"]
            }), scrollOptions
          )
        );
      });

      this.firstBlocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(-50px)", "translateY(100px)"]
            }), scrollOptions
          )
        );
      });

      this.secondBlocks.forEach((block) => {
        this.animations.push(
          Motion.scroll(
            Motion.animate(block, {
              transform: ["translateY(50px)", "translateY(-100px)"]
            }), scrollOptions
          )
        );
      });
    }
  }
}

if (!window.customElements.get("shoppable-media")) {
  customElements.define("shoppable-media", ShoppableMedia);
}


class SlideWithThumbs extends HTMLElement {
  constructor() {
    super();

    this.globalSlide = null;
    this.thumbnailSlide = null;
    this.thumbnailObserver = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.globalSlide) {
      return;
    }

    const settings = theme.helpers.safelyParseJson(this.getAttribute("settings")) || {};

    const defaultSettings = {
      autoplay: false,
      loop: false,
      itemDesktop: 4,
      itemTablet: 1,
      itemMobile: 1,
      direction: "horizontal",
      autoplaySpeed: 3000,
      speed: 400,
      effect: "slide",
      row: 1,
      spacingOnMobile: 0,
      spacingOnDesktop: 0,
      paginationProgressbar: false,
      autoItem: false,
      arrowCenterImage: 0,
      pauseOnMouseEnter: false,
      hasThumbnails: true,
      autoplayVideo: false,
      thumbItemMobile: 4,
      thumbItemDesktop: 4,
    };

    this.settings = {...defaultSettings, ...settings};

    if (this.settings.hasThumbnails) {
      this.initThumbnail();

      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", () => {
          this.initThumbnail();
        });
      }
    }

    this.initSlide();
    this.pauseMedia();
    this.playMedia();
  }

  initSlide() {
    if (this.settings.autoplay) {
      this.settings.autoplay = {
        delay: this.settings.autoplaySpeed,
        pauseOnMouseEnter: this.settings.pauseOnMouseEnter,
      };
    }

    if (!this.settings.itemTablet) {
      if (this.settings.itemDesktop < 2) {
        this.settings.itemTablet = 1;
      } else if (this.settings.itemDesktop < 3) {
        this.settings.itemTablet = 2;
      } else {
        this.settings.itemTablet = 3;
      }
    }

    const container = this.querySelector(".product-slider__navigation");
    const initSwiper = this.querySelector(".product-slider");

    this.globalSlide = new Swiper(initSwiper, {
      slidesPerView: this.settings.autoItem ? "auto" : this.settings.itemMobile,
      spaceBetween: this.settings.spacingOnMobile,
      autoplay: this.settings.autoplay,
      direction: "horizontal",
      loop: this.settings.loop,
      effect: this.settings.effect,
      watchSlidesProgress: true,
      fadeEffect: {
        crossFade: true
      },
      speed: this.settings.speed,
      autoHeight: false,
      allowTouchMove: true,
      navigation: {
        nextEl: [container?.querySelector(".swiper-button-next"), this.querySelector(".swiper-actions--mobile .swiper-button-next")],
        prevEl: [container?.querySelector(".swiper-button-prev"), this.querySelector(".swiper-actions--mobile .swiper-button-prev")],
      },
      pagination: {
        enabled: true,
        clickable: true,
        dynamicBullets: true,
        el: this.querySelector(".swiper-pagination"),
      },
      on: {
        slideChange: () => {
          const thumbnails = this.querySelectorAll(".product-thumbnails-slider .swiper-slide-thumb-active");

          thumbnails[1]?.classList.remove("swiper-slide-thumb-active");
        },
      },
      breakpoints: {
        768: {
          slidesPerView: this.settings.itemTablet,
          spaceBetween: this.settings.spacingOnDesktop,
          pagination: {
            enabled: true,
            clickable: true,
            dynamicBullets: true,
            el: this.querySelector(".swiper-pagination"),
          },
        },
        1025: {
          slidesPerView: this.settings.itemDesktop,
          spaceBetween: this.settings.spacingOnDesktop,
          pagination: {
            enabled: true,
            clickable: true,
            dynamicBullets: true,
            el: this.querySelector(".swiper-pagination"),
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      }
    });
  }

  initThumbnail() {
    const container = this.querySelector(".product-thumbnails-slider");

    if (!container) {
      return;
    }

    this.thumbnailSlide = new Swiper(container, {
      direction: "horizontal",
      spaceBetween: 10,
      slidesPerView: this.settings.thumbItemMobile,
      on: {
        init: () => {
          const thumbnails = container.querySelectorAll(".swiper-slide");

          thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener("click", () => {
              const position = +thumbnail.dataset.position;

              this.functionGoto(position - 1);
            });
          });
        }
      },
      breakpoints: {
        1025: {
          slidesPerView: this.settings.thumbItemDesktop,
          spaceBetween: 20,
        }
      },
    });

    this.thumbnailObserver = new MutationObserver(() => {
      const thumbnails = this.querySelectorAll(".product-thumbnails-slider .swiper-slide-thumb-active");

      if (thumbnails[1]) {
        thumbnails[1]?.classList.remove("swiper-slide-thumb-active");
      }
    });

    this.thumbnailObserver.observe(container, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  pauseMedia() {
    this.globalSlide.on("slideChange", () => {
      theme.helpers.pauseAllMedia();
    });
  }

  playMedia() {
    const autoplay = this.settings.autoplayVideo;

    if (!autoplay) {
      return;
    }

    const vimeoTag = document.createElement("script");

    vimeoTag.src = "https://player.vimeo.com/api/player.js";

    document.head.appendChild(vimeoTag);

    this.globalSlide.on("slideChangeTransitionEnd", function() {
      const activeSlide = this.slides[this.activeIndex];
      const video = activeSlide.querySelector(".media-video");

      if (video) {
        if (video.tagName === "VIDEO") {
          video.play();
        } else if (video.tagName === "IFRAME") {
          if (video.src.includes("vimeo")) {
            const vimeoPlayer = new Vimeo.Player(video);

            vimeoPlayer.play();
          }

          if (video.src.includes("youtube")) {
            video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        }
      }
    });
  }

  functionGoto(position) {
    this.globalSlide?.slideTo(position, 500);
  }
}

if (!window.customElements.get("slide-with-thumbs")) {
  customElements.define("slide-with-thumbs", SlideWithThumbs);
}


class ProductTestimonials extends HTMLElement {
  constructor() {
    super();

    this.globalSlide = null;
    this.thumbnailSlide = null;

    this.mainSlider = this.querySelector(".product-testimonials__main-slider");
    this.productsSlider = this.querySelector(".product-testimonials__products-slider");
    this.productsSliderMobile = this.querySelector(".product-testimonials__products-slider-mobile");

    this.init();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.globalSlide) {
      return;
    }

    const settings = theme.helpers.safelyParseJson(this.getAttribute("settings")) || {};

    const defaultSettings = {
      autoplay: false,
      autoplaySpeed: 3000,
    };

    this.settings = { ...defaultSettings, ...settings };

    this.initThumbnail();
    this.initSlide();

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        this.initThumbnail();
      });
    }
  }

  initSlide() {
    if (this.settings.autoplay) {
      this.settings.autoplay = {
        delay: this.settings.autoplaySpeed,
        pauseOnMouseEnter: this.settings.pauseOnMouseEnter,
      };
    }

    this.globalSlide = new Swiper(this.mainSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      autoplay: this.settings.autoplay,
      direction: "horizontal",
      loop: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: true,
      navigation: {
        nextEl: [...Array.from(this.querySelectorAll(".swiper-button-next"))],
        prevEl: [...Array.from(this.querySelectorAll(".swiper-button-prev"))],
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },
      breakpoints: {
        1025: {
          allowTouchMove: false,
        },
      },
      on: {
        slideChange: (slider) => {
          this.productsSliderMobile.globalSlide.slideTo(slider.realIndex, 500);
        }
      }
    });
  }

  initThumbnail() {
    if (!this.productsSlider) {
      return;
    }

    this.thumbnailSlide = new Swiper(this.productsSlider, {
      effect: "fade",
      itemDesktop: 1,
      itemTablet: 1,
      itemMobile: 1,
      autoHeight: true,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      on: {
        beforeTransitionStart: () => {
          this.productsSlider.classList.add("updating");
        },

        transitionEnd: () => {
          this.productsSlider.classList.remove("updating");
        }
      }
    });
  }

  functionGoto(position) {
    this.globalSlide?.slideTo(position, 500);
  }
}

if (!window.customElements.get("product-testimonials")) {
  customElements.define("product-testimonials", ProductTestimonials);
}


class ScrollingTextBanner extends HTMLElement {
  constructor() {
    super();

    this.headings = this.querySelectorAll(".scrolling-text-banner__heading > span");
    this.handleResizeListener = theme.helpers.debounce(this.handleResize.bind(this), 150);

    this.load();

    window.addEventListener("resize", this.handleResizeListener, { passive: true });
  }

  get mobileEnabled() {
    return true;
  }

  load() {
    if (theme.params.isMotionReduced || (!this.mobileEnabled && (theme.params.isTouchDevice || theme.config.isSmallQuery))) {
      return;
    }

    this.initParallax();
  }

  handleResize() {
    this.resetAnimation();
    this.initParallax();
  }

  initParallax() {
    const animations = [];

    this.headings.forEach((heading) => {
      const direction = heading.closest(".scrolling-text-banner__heading--left") ? "left" : "right";
      const sectionWidth = this.getBoundingClientRect().width;
      const headingWidth = heading.getBoundingClientRect().width;
      const offset = (sectionWidth - headingWidth) / 3;
      const calculatedOffset = direction === "left" ? offset : offset * -1;

      heading.classList.add("inline-block");

      animations.push(
        Motion.scroll(
          Motion.animate(heading, {
            transform: [`translateX(${calculatedOffset}px)`, "translateX(0)"]
          }), {
            target: this,
            offset: [
              [0, 0.5], [0.5, 0]
            ]
          })
      );
    });

    this.animations = animations;
  }

  resetAnimation() {
    if (theme.params.isMotionReduced || (this.mobileEnabled && (theme.params.isTouchDevice || theme.config.isSmallQuery))) {
      return;
    }

    this.animations?.forEach((animation) => {
      animation();
    });

    setTimeout(() => {
      this.headings.forEach((heading) => {
        Motion.animate(heading, {
          transform: "translateX(0)"
        }, {
          duration: 0
        });
      });
    });
  }
}

if (!window.customElements.get("scrolling-text-banner")) {
  customElements.define("scrolling-text-banner", ScrollingTextBanner);
}


class ScrollingSlides extends HTMLElement {
  constructor() {
    super();

    this.slides = Array.from(this.querySelectorAll(".scrolling-slides__slide"));
    this.wrapper = this.querySelector(".scrolling-slides__wrapper");
    this.sectionHeight = 0;
    this.handleResizeListener = theme.helpers.debounce(this.handleResize.bind(this), 150);

    this.load();

    window.addEventListener("resize", this.handleResizeListener, { passive: true });

    document.addEventListener("breakpoint:sm:match", this.unload.bind(this));
    document.addEventListener("breakpoint:sm:unmatch", this.load.bind(this));
  }

  get mobileEnabled() {
    return false;
  }

  setSectionHeight() {
    let width = 0;

    this.slides.forEach((slide, index) => {
      width += slide.getBoundingClientRect().width;
    });

    this.sectionHeight = width;

    this.style.setProperty("--scrolling-height", `${width}px`);
  }

  load() {
    if (theme.params.isMotionReduced || (!this.mobileEnabled && (theme.params.isTouchDevice || theme.config.isSmallQuery))) {
      return;
    }

    this.setSectionHeight();
    this.initParallax();
  }

  handleResize() {
    this.resetAnimation();
    this.setSectionHeight();
    this.initParallax();
  }

  initParallax() {
    const lastSlide = this.slides[this.slides.length - 1];
    const slideWidth = lastSlide.getBoundingClientRect().width;
    const translateToPosition = this.sectionHeight - slideWidth - ((window.innerWidth - slideWidth) / 2);

    const animations = [];

    animations.push(
      Motion.scroll(
        Motion.animate(this.wrapper, {
          transform: ["translateX(0)", `translateX(-${translateToPosition}px)`]
        }), {
          target: this,
          offset: [
            [0, 0], [1, 1]
          ]
        })
    );

    animations.push(
      Motion.scroll(
        Motion.animate(this, {
          "--overlay-opacity": [80, 0]
        }), {
          target: this,
          offset: [
            [1, 0], [1, 1]
          ]
        })
    );

    animations.push(
      Motion.scroll(
        Motion.animate(lastSlide, {
          transform: ["scale(0.6)", "scale(1)"]
        }), {
          target: this,
          offset: [
            [1, 0], [1, 1]
          ]
        })
    );

    this.slides.forEach((slide) => {
      if (slide.classList.contains("scrolling-slides__slide--content")) {
        return;
      }

      Motion.inView(slide, (element, enterInfo) => {
        element.classList.add("scrolling-slides__slide--visible");

        return () => {
          element.classList.remove("scrolling-slides__slide--visible");
        }
      }, {
        amount: 0.2
      });
    });

    this.animations = animations;
  }

  resetAnimation() {
    if (theme.params.isMotionReduced || (this.mobileEnabled && (theme.params.isTouchDevice || theme.config.isSmallQuery))) {
      return;
    }

    const lastSlide = this.slides[this.slides.length - 1];

    this.animations?.forEach((animation) => {
      animation();
    });

    setTimeout(() => {
      Motion.animate(this.wrapper, {
        transform: "translateX(0)"
      }, {
        duration: 0
      });

      Motion.animate(lastSlide, {
        transform: "scale(1)"
      }, {
        duration: 0
      });
    });

    this.slides.forEach((slide) => {
      slide.classList.remove("scrolling-slides__slide--visible");
    });
  }

  unload() {
    this.style.removeProperty("--scrolling-height");
  }
}

if (!window.customElements.get("scrolling-slides")) {
  customElements.define("scrolling-slides", ScrollingSlides);
}

